/* eslint-disable */
import * as Types from './types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export const UserFragmentDoc = gql`
    fragment User on User {
  id
  email
  firstName
  lastName
  phone
  isStaff
  __typename
  metadata {
    key
    value
  }
  avatar(size: 128) {
    url
  }
  restrictedAccessToChannels
}
    `;
export const ApplicationsFragmentDoc = gql`
    fragment Applications on InstallmentApplication {
  id
  phoneNumber
  passportNumber
  dateOfBirth
  cardNumber
  cardExpirationDate
  cardCvv
  photoWithPassport
  frontSideOfPassport
  backSideOfPassport
  status
  user {
    ...User
  }
}
    ${UserFragmentDoc}`;
export const BannerBasicFragmentDoc = gql`
    fragment BannerBasic on Banner {
  id
  title
  image
  imageMd
  imageSm
  url
  activeFrom
  activeUntil
  showButton
  contentPosition
  bannerType
  buttonColor
  buttonText
}
    `;
export const BrandBasicFragmentDoc = gql`
    fragment BrandBasic on Brand {
  id
  name
  image
  description
  isActive
  isRecommended
  metaDescription
  metaKeywords
  seoTitle
  sortOrder
  slug
}
    `;
export const CategoryTranslationBasicFragmentDoc = gql`
    fragment CategoryTranslationBasic on Category {
  id
  name
  slug
  description
  icon
  level
  isActive
  isInCatalog
  isBottom
  isPopular
  translation(languageCode: $languageCode) {
    name
  }
  parent {
    id
    name
    slug
    icon
    level
    isActive
    isInCatalog
    isPopular
    isBottom
  }
}
    `;
export const ProductsBasicTranslatedFragmentDoc = gql`
    fragment ProductsBasicTranslated on Product {
  id
  name
  slug
  brand {
    ...BrandBasic
  }
  category {
    ...CategoryTranslationBasic
  }
  rating
  isAvailable
  barcode
  thumbnail(size: 200) {
    url
    alt
  }
  defaultVariant {
    id
    name
    availability
    translation(languageCode: $languageCode) {
      name
    }
    media {
      id
      alt
      url(size: 3000)
    }
    pricing {
      price {
        net {
          currency
          amount
        }
      }
      percentageDiscountAmount
      priceUndiscounted {
        net {
          currency
          amount
        }
      }
      discount {
        net {
          currency
          amount
        }
      }
      installmentPrice4 {
        currency
        amount
      }
      installmentPrice6 {
        currency
        amount
      }
      installmentPrice12 {
        currency
        amount
      }
      bonusesAmount
    }
  }
  variants {
    id
    name
    availability
    translation(languageCode: $languageCode) {
      name
    }
    media {
      id
      alt
      url(size: 3000)
    }
    pricing {
      price {
        net {
          currency
          amount
        }
      }
      percentageDiscountAmount
      priceUndiscounted {
        net {
          currency
          amount
        }
      }
      discount {
        net {
          currency
          amount
        }
      }
      installmentPrice4 {
        currency
        amount
      }
      installmentPrice6 {
        currency
        amount
      }
      installmentPrice12 {
        currency
        amount
      }
      bonusesAmount
    }
  }
}
    ${BrandBasicFragmentDoc}
${CategoryTranslationBasicFragmentDoc}`;
export const CategoryWithNestedChildrenFragmentDoc = gql`
    fragment CategoryWithNestedChildren on Category {
  id
  name
  slug
  description
  icon
  level
  isActive
  isInCatalog
  isBottom
  isPopular
  seoTitle
  metaDescription
  translation(languageCode: $languageCode) {
    name
  }
  parent {
    id
    name
    slug
    icon
    level
    isActive
    isInCatalog
    isPopular
    isBottom
  }
  children(first: 50) {
    edges {
      node {
        id
        name
        slug
        icon
        level
        isActive
        isInCatalog
        isPopular
        isBottom
        translation(languageCode: $languageCode) {
          name
        }
        products(first: 4) {
          edges {
            node {
              ...ProductsBasicTranslated
              translation(languageCode: $languageCode) {
                name
              }
            }
          }
        }
        children(first: 50) {
          edges {
            node {
              id
              name
              slug
              icon
              level
              isActive
              isInCatalog
              isPopular
              isBottom
              translation(languageCode: $languageCode) {
                name
              }
            }
          }
        }
      }
    }
  }
}
    ${ProductsBasicTranslatedFragmentDoc}`;
export const CategoryBasicFragmentDoc = gql`
    fragment CategoryBasic on Category {
  id
  name
  slug
  description
  icon
  level
  isActive
  isInCatalog
  isBottom
  isPopular
  parent {
    id
    name
    slug
    icon
    level
    isActive
    isInCatalog
    isPopular
    isBottom
  }
  children(first: 100) {
    edges {
      node {
        id
        name
        slug
      }
    }
  }
}
    `;
export const AttributeBasicFragmentDoc = gql`
    fragment AttributeBasic on Attribute {
  id
  name
  type
  unit
  withChoices
  inputType
  isMain
  category {
    id
    name
    description
  }
}
    `;
export const AttributeValueBasicFragmentDoc = gql`
    fragment AttributeValueBasic on AttributeValue {
  id
  name
  slug
  value
  inputType
  file {
    url
    contentType
  }
  boolean
  plainText
  richText
  date
  dateTime
}
    `;
export const ProductVariantBasicFragmentDoc = gql`
    fragment ProductVariantBasic on ProductVariant {
  id
  name
  availability
  labels(first: 10) {
    edges {
      node {
        id
        name
        color
        content
        description
        backgroundColor
      }
      cursor
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
  sku
  media {
    id
    alt
    url(size: 3000)
  }
  pricing {
    price {
      net {
        currency
        amount
      }
    }
    percentageDiscountAmount
    priceUndiscounted {
      net {
        currency
        amount
      }
    }
    discount {
      net {
        currency
        amount
      }
    }
    installmentPrice4 {
      currency
      amount
    }
    installmentPrice6 {
      currency
      amount
    }
    installmentPrice12 {
      currency
      amount
    }
    bonusesAmount
  }
  attributes {
    attribute {
      ...AttributeBasic
    }
    values {
      ...AttributeValueBasic
    }
  }
  attributesCategories {
    id
    name
    description
  }
  channelListings {
    id
    installment {
      partner {
        id
        name
        logo
        partnerName
        isActive
        sortOrder
        isOwn
        externalPartnerName
      }
      months {
        monthsAmount
        totalPrice {
          currency
          amount
        }
      }
    }
  }
  product {
    id
    name
    slug
    variants {
      id
      name
      sku
      trackInventory
      quantityLimitPerCustomer
    }
    category {
      id
      name
      slug
      description
      icon
      level
      isActive
      isInCatalog
      isBottom
      isPopular
      parent {
        id
        name
        slug
        icon
        level
        isActive
        isInCatalog
        isPopular
        isBottom
      }
      ancestors(first: 10) {
        edges {
          node {
            id
            description
            name
            slug
            level
          }
        }
      }
    }
    brand {
      id
      name
      image
      description
      isActive
      isRecommended
    }
    reviews(first: 10) {
      totalCount
    }
    attributes {
      attribute {
        ...AttributeBasic
      }
      values {
        ...AttributeValueBasic
      }
    }
  }
  gifts {
    id
    name
    product {
      id
      name
      slug
      category {
        id
        name
        slug
      }
    }
    giftsPrice {
      currency
      amount
    }
    media {
      id
      alt
      url(size: 3000)
    }
  }
}
    ${AttributeBasicFragmentDoc}
${AttributeValueBasicFragmentDoc}`;
export const ProductsBasicFragmentDoc = gql`
    fragment ProductsBasic on Product {
  id
  name
  slug
  brand {
    ...BrandBasic
  }
  category {
    ...CategoryBasic
  }
  rating
  isAvailable
  barcode
  thumbnail(size: 200) {
    url
    alt
  }
  defaultVariant {
    ...ProductVariantBasic
  }
  variants {
    ...ProductVariantBasic
  }
}
    ${BrandBasicFragmentDoc}
${CategoryBasicFragmentDoc}
${ProductVariantBasicFragmentDoc}`;
export const CategoryWithNestedChildrenSortByFragmentDoc = gql`
    fragment CategoryWithNestedChildrenSortBy on Category {
  id
  name
  slug
  description
  icon
  level
  isActive
  isInCatalog
  isBottom
  isPopular
  parent {
    id
    name
    slug
    icon
    level
    isActive
    isInCatalog
    isPopular
    isBottom
  }
  children(first: 50) {
    edges {
      node {
        id
        name
        slug
        icon
        level
        isActive
        isInCatalog
        isPopular
        isBottom
        products(first: 4, sortBy: $productSortBy) {
          edges {
            node {
              ...ProductsBasic
            }
          }
        }
        children(first: 50) {
          edges {
            node {
              id
              name
              slug
              icon
              level
              isActive
              isInCatalog
              isPopular
              isBottom
            }
          }
        }
      }
    }
  }
}
    ${ProductsBasicFragmentDoc}`;
export const CheckoutLineFragmentFragmentDoc = gql`
    fragment checkoutLineFragment on CheckoutLine {
  id
  metadata {
    key
    value
  }
  variant {
    id
    name
    sku
    pricing {
      price {
        gross {
          amount
          currency
        }
      }
    }
  }
  quantity
  unitPrice {
    gross {
      amount
      currency
    }
    net {
      amount
      currency
    }
  }
  undiscountedUnitPrice {
    amount
    currency
  }
  totalPrice {
    gross {
      amount
      currency
    }
    net {
      amount
      currency
    }
  }
  undiscountedTotalPrice {
    amount
    currency
  }
  requiresShipping
  isGift
}
    `;
export const CityShippingMethodsBasicFragmentDoc = gql`
    fragment CityShippingMethodsBasic on CityShippingMethod {
  id
  city
  shortDescription
  weekendDays
  weekendDates
  price
  freeOverThreshold
  isActive
  timeRanges
  isYandex
  yandexDeliveryPrice
}
    `;
export const CollectionDetailsFragmentDoc = gql`
    fragment CollectionDetails on Collection {
  id
  name
  backgroundImage(size: 3000) {
    alt
    url
  }
  slug
  description
  metaDescription
  seoTitle
  sortOrder
  isInCatalog
  isBottom
}
    `;
export const ContentFragmentDoc = gql`
    fragment Content on Page {
  id
  title
  slug
  isActive
  description
  image
  innerImage
  isActive
  createdAt
  section
  pageType {
    id
    name
  }
  section
  pageFormat
  blocks {
    id
    sortOrder
    content {
      __typename
      ... on PageAccordionBlock {
        id
        title
        text
        subsections {
          id
          title
          text
          sortOrder
        }
      }
      ... on PageBackgroundImageTextBlock {
        id
        backgroundImage: image
        markdownText
        color
        contentPosition
      }
      ... on PageCardBlock {
        id
        cardImage: image
        markdownText
      }
      ... on PageImageButtonsBlock {
        id
        buttonsImage: image
        markdownText
        color
        buttons {
          id
          text
          url
          backgroundColor
          color
        }
      }
      ... on PageImageMdBlock {
        id
        mdImage: image
        markdownText
        variant
      }
      ... on PageListImageBlock {
        id
        listImageImage: image
        markdownText
        items {
          id
          listItemImageImage: image
          text
        }
      }
      ... on PageNewsBlock {
        id
        newsImage: image
        markdownText
      }
      ... on PageRichTextBlock {
        id
        markdownText
      }
      ... on PageTextBlock {
        id
        markdownText
        title
        withSeparator
      }
      ... on PageTextWithImageBlock {
        id
        title
        markdownText
        textWithImageTopImage: topImage
        bottomImages {
          id
          image
        }
      }
      ... on PageTitleMediaBlock {
        id
        title
        items {
          id
          mediaUrl
        }
      }
      ... on PageProductCardBlock {
        id
        productVariant {
          id
          name
          rating
          media {
            id
            url(size: 3000)
          }
          reviews {
            totalCount
          }
          labels(first: 30) {
            edges {
              node {
                name
                color
                content
                backgroundColor
                isActive
              }
            }
          }
          product {
            name
            variants {
              attributes {
                attribute {
                  ...AttributeBasic
                }
                values {
                  ...AttributeValueBasic
                }
              }
            }
          }
          pricing {
            priceUndiscounted {
              net {
                amount
              }
            }
          }
        }
        buttonText
        buttonUrl
      }
      ... on PageProductTableBlock {
        id
        title
        productVariants(first: 30) {
          edges {
            node {
              ...ProductVariantBasic
            }
          }
        }
      }
    }
  }
}
    ${AttributeBasicFragmentDoc}
${AttributeValueBasicFragmentDoc}
${ProductVariantBasicFragmentDoc}`;
export const MenuFragmentDoc = gql`
    fragment Menu on Menu {
  id
  name
  items {
    id
    name
  }
}
    `;
export const MenuItemFragmentDoc = gql`
    fragment MenuItem on MenuItem {
  category {
    id
    name
    translation(languageCode: $languageCode) {
      name
    }
  }
  collection {
    id
    name
    translation(languageCode: $languageCode) {
      name
    }
  }
  id
  level
  name
  translation(languageCode: $languageCode) {
    name
  }
  page {
    id
    title
  }
  url
}
    `;
export const MenuItemNestedFragmentDoc = gql`
    fragment MenuItemNested on MenuItem {
  ...MenuItem
  children {
    ...MenuItem
    children {
      ...MenuItem
      children {
        ...MenuItem
        children {
          ...MenuItem
          children {
            ...MenuItem
            children {
              ...MenuItem
            }
          }
        }
      }
    }
  }
}
    ${MenuItemFragmentDoc}`;
export const MenuDetailsFragmentDoc = gql`
    fragment MenuDetails on Menu {
  id
  items {
    ...MenuItemNested
    translation(languageCode: $languageCode) {
      name
    }
  }
  name
}
    ${MenuItemNestedFragmentDoc}`;
export const UserBasicFragmentDoc = gql`
    fragment UserBasic on User {
  id
  email
  phone
  firstName
  lastName
  isStaff
  isActive
  isConfirmed
  avatar {
    url
    alt
  }
  bonusesBarcode
  bonusesQr
  bonusesAmount
  defaultShippingAddress {
    id
    name
    city
    streetAddress
    houseNumber
    apartmentNumber
    houseSection
    doorCode
    note
    floor
    isDefaultShippingAddress
    isDefaultBillingAddress
  }
  addresses {
    id
    name
    city
    streetAddress
    houseNumber
    apartmentNumber
    houseSection
    doorCode
    note
    floor
    isDefaultShippingAddress
    isDefaultBillingAddress
  }
  viewedVariants(first: 5) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      node {
        ...ProductVariantBasic
      }
      cursor
    }
    totalCount
  }
}
    ${ProductVariantBasicFragmentDoc}`;
export const AddressBasicFragmentDoc = gql`
    fragment AddressBasic on Address {
  id
  name
  city
  streetAddress
  houseNumber
  apartmentNumber
  houseSection
  doorCode
  note
  floor
  isDefaultShippingAddress
  isDefaultBillingAddress
}
    `;
export const WarehouseBasicFragmentDoc = gql`
    fragment WarehouseBasic on Warehouse {
  id
  type
  name
  clickAndCollectOption
  store {
    id
    address {
      ...AddressBasic
    }
    landmark
    image
    weekends
    workSchedule
    longitude
    latitude
  }
}
    ${AddressBasicFragmentDoc}`;
export const OrderBasicFragmentDoc = gql`
    fragment OrderBasic on Order {
  id
  status
  isFastBuy
  number
  paymentMethodName
  paymentStatusDisplay
  installmentPartnerName
  installmentPeriod
  deliveryMethod {
    __typename
    ... on Warehouse {
      id
      name
      store {
        workSchedule
      }
    }
    ... on CityShippingMethod {
      id
    }
    ... on RegionalShippingMethod {
      id
      name
    }
  }
  user {
    ...UserBasic
  }
  total {
    net {
      currency
      amount
    }
  }
  availableCollectionPoints {
    ...WarehouseBasic
  }
  shippingIsYandex
  collectionPointName
  shippingDate
  shippingStartTime
  shippingEndTime
  appliedBonusesAmount
  shippingAddress {
    id
    name
    city
    streetAddress
    houseNumber
    apartmentNumber
    houseSection
    doorCode
    note
    floor
    isDefaultShippingAddress
    isDefaultBillingAddress
  }
  shippingPrice {
    net {
      currency
      amount
    }
  }
  totalBonuses
  appliedBonusesAmount
  voucher {
    id
    name
  }
  voucherCode
  giftsPrice {
    currency
    amount
  }
  totalBenefit {
    currency
    amount
  }
  undiscountedTotal {
    net {
      currency
      amount
    }
  }
  discountBenefit {
    currency
    amount
  }
  lines {
    productName
    variantName
    productVariantId
    quantity
    variant {
      ...ProductVariantBasic
    }
    isGift
    thumbnail(size: 3000) {
      url
      alt
    }
  }
  installmentsWithoutIntegration {
    partner {
      id
      name
      logo
      partnerName
      isActive
      sortOrder
      isOwn
      externalPartnerName
    }
    months {
      month
      price {
        currency
        amount
      }
      monthlyPayment {
        currency
        amount
      }
    }
  }
}
    ${UserBasicFragmentDoc}
${WarehouseBasicFragmentDoc}
${ProductVariantBasicFragmentDoc}`;
export const StoreBranchFragmentFragmentDoc = gql`
    fragment StoreBranchFragment on StoreBranch {
  id
  address {
    id
    name
    city
    streetAddress
  }
  phone
  landmark
  image
  workSchedule
  weekends
  longitude
  latitude
  seoTitle
  metaDescription
  metaKeywords
}
    `;
export const SimilarProductFragmentDoc = gql`
    fragment SimilarProduct on Product {
  id
  name
  slug
  reviewsData
  activeReviewsCount
  category {
    ...CategoryBasic
  }
  rating
  isAvailable
  barcode
  thumbnail(size: 200) {
    url
    alt
  }
  defaultVariant {
    ...ProductVariantBasic
  }
  variants {
    ...ProductVariantBasic
  }
  similarProducts(first: 10) {
    edges {
      node {
        id
        name
        slug
        defaultVariant {
          ...ProductVariantBasic
        }
      }
    }
  }
}
    ${CategoryBasicFragmentDoc}
${ProductVariantBasicFragmentDoc}`;
export const OrderFragmentFragmentDoc = gql`
    fragment OrderFragment on Order {
  id
  number
  origin
  user {
    ...UserBasic
  }
  isFastBuy
  status
  created
  createdFromDraft
  shippingDate
  shippingStartTime
  shippingEndTime
  shippingIsYandex
  totalBenefit {
    amount
    currency
  }
  voucher {
    id
    name
  }
  voucherCode
  totalBonuses
  appliedBonusesAmount
  paymentMethodName
  installmentPartnerName
  installmentPeriod
  installmentStatus
  installmentMonthlyPaymentAmount
  totalBalance {
    amount
    currency
  }
  totalCanceled {
    amount
    currency
  }
  totalCharged {
    amount
    currency
  }
  totalAuthorized {
    amount
    currency
  }
  shippingAddress {
    ...AddressBasic
  }
  shippingPrice {
    net {
      currency
      amount
    }
  }
  collectionPointName
  deliveryMethod {
    __typename
    ... on Warehouse {
      id
      name
      store {
        ...StoreBranchFragment
      }
      clickAndCollectOption
    }
    ... on CityShippingMethod {
      id
      city
      shortDescription
      weekendDays
      weekendDates
      price
      freeOverThreshold
      timeRanges
      isActive
    }
    ... on RegionalShippingMethod {
      id
      name
      description
      image
      isActive
    }
  }
  lines {
    id
    productName
    variantName
    translatedProductName
    translatedVariantName
    productVariantId
    productSku
    quantity
    unitDiscount {
      amount
    }
    variant {
      ...ProductVariantBasic
    }
    thumbnail {
      url
      alt
    }
    totalPrice {
      net {
        currency
        amount
      }
    }
    isGift
  }
  linesSimilarProducts(first: 10) {
    edges {
      node {
        ...SimilarProduct
      }
    }
  }
  total {
    net {
      currency
      amount
    }
  }
  availableCollectionPoints {
    ...WarehouseBasic
  }
  totalBonuses
  giftsPrice {
    currency
    amount
  }
  totalBenefit {
    currency
    amount
  }
  undiscountedTotal {
    net {
      currency
      amount
    }
  }
  discountBenefit {
    currency
    amount
  }
  installmentsWithoutIntegration {
    partner {
      id
      name
      logo
      partnerName
      isActive
      sortOrder
      isOwn
      externalPartnerName
    }
    months {
      month
      price {
        currency
        amount
      }
      monthlyPayment {
        currency
        amount
      }
    }
  }
}
    ${UserBasicFragmentDoc}
${AddressBasicFragmentDoc}
${StoreBranchFragmentFragmentDoc}
${ProductVariantBasicFragmentDoc}
${SimilarProductFragmentDoc}
${WarehouseBasicFragmentDoc}`;
export const PaymentTabBasicFragmentDoc = gql`
    fragment PaymentTabBasic on PaymentTab {
  id
  name
  method
  description
  label
  labelColor
  image1
  image2
  image3
  translation(languageCode: $languageCode) {
    id
    name
    description
    label
  }
}
    `;
export const AttributeBasicTranslationFragmentDoc = gql`
    fragment AttributeBasicTranslation on Attribute {
  id
  name
  translation(languageCode: $languageCode) {
    name
  }
  type
  unit
  withChoices
  inputType
  isMain
  category {
    id
    name
    description
    translation(languageCode: $languageCode) {
      name
    }
  }
}
    `;
export const AttributeValueBasicTranslationFragmentDoc = gql`
    fragment AttributeValueBasicTranslation on AttributeValue {
  id
  name
  translation(languageCode: $languageCode) {
    name
  }
  slug
  value
  inputType
  file {
    url
    contentType
  }
  boolean
  plainText
  richText
  date
  dateTime
}
    `;
export const ProductVariantTranslationsBasicFragmentDoc = gql`
    fragment ProductVariantTranslationsBasic on ProductVariant {
  id
  name
  availability
  seoTitle
  metaDescription
  translation(languageCode: $languageCode) {
    name
  }
  stocks {
    id
    warehouse {
      id
      name
      store {
        id
        address {
          city
        }
      }
    }
    productVariant {
      id
      name
      sku
      translation(languageCode: $languageCode) {
        name
      }
    }
    quantity
    quantityAllocated
    quantityReserved
  }
  labels(first: 10) {
    edges {
      node {
        id
        name
        color
        backgroundColor
        content
      }
      cursor
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
  sku
  media {
    id
    alt
    url(size: 3000)
  }
  selectionAttributes: attributes(variantSelection: VARIANT_SELECTION) {
    attribute {
      ...AttributeBasic
    }
    values {
      ...AttributeValueBasic
    }
  }
  pricing {
    price {
      net {
        currency
        amount
      }
    }
    percentageDiscountAmount
    priceUndiscounted {
      net {
        currency
        amount
      }
    }
    discount {
      net {
        currency
        amount
      }
    }
    installmentPrice4 {
      currency
      amount
    }
    installmentPrice6 {
      currency
      amount
    }
    installmentPrice12 {
      currency
      amount
    }
    bonusesAmount
  }
  attributes {
    attribute {
      ...AttributeBasicTranslation
      translation(languageCode: $languageCode) {
        id
        name
        language {
          code
          language
        }
      }
    }
    values {
      ...AttributeValueBasicTranslation
      translation(languageCode: $languageCode) {
        id
        name
        language {
          code
          language
        }
      }
    }
  }
  attributesCategories {
    id
    name
    translation(languageCode: $languageCode) {
      id
      name
      language {
        code
        language
      }
    }
    description
  }
  channelListings {
    id
    installment {
      partner {
        id
        name
        translation(languageCode: $languageCode) {
          name
        }
        logo
        partnerName
        isActive
        sortOrder
        isOwn
        externalPartnerName
      }
      months {
        monthsAmount
        totalPrice {
          currency
          amount
        }
      }
    }
  }
  product {
    id
    name
    slug
    translation(languageCode: $languageCode) {
      name
    }
    variants {
      id
      name
      translation(languageCode: $languageCode) {
        name
      }
      sku
      trackInventory
      quantityLimitPerCustomer
    }
    category {
      id
      name
      slug
      description
      icon
      level
      isActive
      isInCatalog
      isBottom
      isPopular
      translation(languageCode: $languageCode) {
        name
      }
      parent {
        id
        name
        translation(languageCode: $languageCode) {
          name
        }
        slug
        icon
        level
        isActive
        isInCatalog
        isPopular
        isBottom
      }
      ancestors(first: 10) {
        edges {
          node {
            id
            description
            name
            slug
            level
            translation(languageCode: $languageCode) {
              name
            }
          }
        }
      }
    }
    brand {
      id
      name
      image
      description
      isActive
      isRecommended
      translation(languageCode: $languageCode) {
        name
      }
    }
    reviews(first: 10) {
      totalCount
    }
    attributes {
      attribute {
        ...AttributeBasic
        translation(languageCode: $languageCode) {
          name
        }
      }
      values {
        ...AttributeValueBasic
        translation(languageCode: $languageCode) {
          name
        }
      }
    }
  }
  gifts {
    id
    name
    translation(languageCode: $languageCode) {
      name
    }
    product {
      id
      name
      slug
    }
    media {
      id
      alt
      url(size: 3000)
    }
  }
}
    ${AttributeBasicFragmentDoc}
${AttributeValueBasicFragmentDoc}
${AttributeBasicTranslationFragmentDoc}
${AttributeValueBasicTranslationFragmentDoc}`;
export const ProductBasicFragmentDoc = gql`
    fragment ProductBasic on Product {
  id
  name
  slug
  reviewsData
  description
  activeReviewsCount
  defaultTab
  seoTitle
  metaDescription
  translation(languageCode: $languageCode) {
    name
    description
  }
  brand {
    ...BrandBasic
    translation(languageCode: $languageCode) {
      name
    }
  }
  category {
    ...CategoryTranslationBasic
    translation(languageCode: $languageCode) {
      name
    }
  }
  rating
  isAvailable
  barcode
  thumbnail(size: 200) {
    url
    alt
  }
  attributes {
    attribute {
      ...AttributeBasic
      translation(languageCode: $languageCode) {
        name
      }
    }
    values {
      ...AttributeValueBasic
      translation(languageCode: $languageCode) {
        name
      }
    }
  }
  attributesCategories {
    id
    name
    description
    translation(languageCode: $languageCode) {
      name
    }
  }
  reviews(first: 10) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
    edges {
      node {
        id
        productVariant {
          id
          name
        }
        advantages
        disadvantages
        publishedAt
        rating
        status
      }
      cursor
    }
  }
  defaultVariant {
    ...ProductVariantTranslationsBasic
  }
  variants {
    ...ProductVariantTranslationsBasic
    translation(languageCode: $languageCode) {
      name
    }
  }
  similarProducts(first: 10, filter: $similarProductsFilter) {
    edges {
      node {
        id
        name
        slug
        translation(languageCode: $languageCode) {
          name
        }
        defaultVariant {
          ...ProductVariantBasic
          translation(languageCode: $languageCode) {
            name
          }
        }
        variants {
          ...ProductVariantTranslationsBasic
          translation(languageCode: $languageCode) {
            name
          }
        }
      }
    }
  }
  similarProductsCategories {
    ...CategoryTranslationBasic
    translation(languageCode: $languageCode) {
      name
    }
  }
}
    ${BrandBasicFragmentDoc}
${CategoryTranslationBasicFragmentDoc}
${AttributeBasicFragmentDoc}
${AttributeValueBasicFragmentDoc}
${ProductVariantTranslationsBasicFragmentDoc}
${ProductVariantBasicFragmentDoc}`;
export const ProductWithDetailsFragmentDoc = gql`
    fragment ProductWithDetails on Product {
  ...ProductBasic
  description
  category {
    id
    name
  }
}
    ${ProductBasicFragmentDoc}`;
export const ProductVariantBasicNotTokenFragmentDoc = gql`
    fragment ProductVariantBasicNotToken on ProductVariant {
  id
  name
  availability
  labels(first: 10) {
    edges {
      node {
        id
        name
        color
        content
        description
        backgroundColor
      }
      cursor
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
  sku
  media {
    id
    alt
    url(size: 3000)
  }
  pricing {
    price {
      net {
        currency
        amount
      }
    }
    percentageDiscountAmount
    priceUndiscounted {
      net {
        currency
        amount
      }
    }
    discount {
      net {
        currency
        amount
      }
    }
    installmentPrice4 {
      currency
      amount
    }
    installmentPrice6 {
      currency
      amount
    }
    installmentPrice12 {
      currency
      amount
    }
    bonusesAmount
  }
  attributes {
    attribute {
      ...AttributeBasic
    }
    values {
      ...AttributeValueBasic
    }
  }
  attributesCategories {
    id
    name
    description
  }
  product {
    id
    name
    slug
    variants {
      id
      name
      sku
      trackInventory
      quantityLimitPerCustomer
    }
    category {
      id
      name
      slug
      description
      icon
      level
      isActive
      isInCatalog
      isBottom
      isPopular
      parent {
        id
        name
        slug
        icon
        level
        isActive
        isInCatalog
        isPopular
        isBottom
      }
      ancestors(first: 10) {
        edges {
          node {
            id
            description
            name
            slug
            level
          }
        }
      }
    }
    brand {
      id
      name
      image
      description
      isActive
      isRecommended
    }
    reviews(first: 10) {
      totalCount
    }
    attributes {
      attribute {
        ...AttributeBasic
      }
      values {
        ...AttributeValueBasic
      }
    }
  }
  gifts {
    id
    name
    product {
      id
      name
      slug
      category {
        id
        name
        slug
      }
    }
    giftsPrice {
      currency
      amount
    }
    media {
      id
      alt
      url(size: 3000)
    }
  }
}
    ${AttributeBasicFragmentDoc}
${AttributeValueBasicFragmentDoc}`;
export const StickerFragmentDoc = gql`
    fragment Sticker on ProductVariantLabel {
  id
  name
  content
  description
  color
  isActive
  backgroundColor
}
    `;
export const DicountDetailsFragmentDoc = gql`
    fragment DicountDetails on Promotion {
  id
  name
  slug
  image
  type
  format
  innerImage
  description
  endDate
  startDate
  translation(languageCode: $languageCode) {
    name
  }
}
    `;
export const DicountDetailsTranslationFragmentDoc = gql`
    fragment DicountDetailsTranslation on Promotion {
  id
  name
  translation(languageCode: $languageCode) {
    name
  }
  slug
  image
  type
  format
  innerImage
  description
  seoTitle
  metaDescription
  metaKeywords
  startDate
  endDate
}
    `;
export const RedirectsBasicsFragmentDoc = gql`
    fragment RedirectsBasics on Redirect {
  id
  oldUrl
  newUrl
}
    `;
export const ReviewBasicFragmentDoc = gql`
    fragment ReviewBasic on Review {
  id
  user {
    id
    firstName
    lastName
    avatar {
      url
      alt
    }
  }
  advantages
  disadvantages
  description
  rating
  status
  publishedAt
  productVariant {
    id
    name
  }
}
    `;
export const ShopFragmentDoc = gql`
    fragment Shop on Shop {
  googleAnalyticsCode
  yandexMetrikaCode
  facebookPixelCode
  jivoChatCode
  siteSeoTitle
  description
  googleSearchConsoleCode
}
    `;
export const VacancyFragmentFragmentDoc = gql`
    fragment VacancyFragment on Vacancy {
  id
  name
  description
  city
  salaryFrom
  salaryUpTo
  contactName
  contactPhone
  isBurning
  isActive
}
    `;
export const CollectiontVariantFragmentDoc = gql`
    fragment CollectiontVariant on ProductVariant {
  id
  name
  availability
  labels(first: 10) {
    edges {
      node {
        id
        name
        color
        backgroundColor
      }
    }
  }
  media {
    id
    alt
    url(size: 3000)
  }
  translation(languageCode: $languageCode) {
    name
  }
  pricing {
    price {
      net {
        currency
        amount
      }
    }
    percentageDiscountAmount
    priceUndiscounted {
      net {
        currency
        amount
      }
    }
    discount {
      net {
        currency
        amount
      }
    }
    installmentPrice4 {
      currency
      amount
    }
    installmentPrice6 {
      currency
      amount
    }
    installmentPrice12 {
      currency
      amount
    }
    bonusesAmount
  }
  attributes {
    attribute {
      ...AttributeBasic
    }
    values {
      ...AttributeValueBasic
    }
  }
  product {
    id
    name
    slug
    attributes {
      attribute {
        ...AttributeBasic
      }
      values {
        ...AttributeValueBasic
      }
    }
    category {
      id
      name
      slug
      translation(languageCode: $languageCode) {
        name
      }
    }
  }
}
    ${AttributeBasicFragmentDoc}
${AttributeValueBasicFragmentDoc}`;
export const NewArrivalsVariantFragmentDoc = gql`
    fragment NewArrivalsVariant on ProductVariant {
  id
  name
  availability
  labels(first: 10) {
    edges {
      node {
        id
        name
        color
        backgroundColor
      }
    }
  }
  media {
    id
    alt
    url(size: 3000)
  }
  translation(languageCode: $languageCode) {
    name
  }
  pricing {
    price {
      net {
        currency
        amount
      }
    }
    percentageDiscountAmount
    priceUndiscounted {
      net {
        currency
        amount
      }
    }
    discount {
      net {
        currency
        amount
      }
    }
    installmentPrice4 {
      currency
      amount
    }
    installmentPrice6 {
      currency
      amount
    }
    installmentPrice12 {
      currency
      amount
    }
    bonusesAmount
  }
  product {
    id
    name
    slug
    category {
      id
      name
    }
  }
}
    `;
export const TopProductVariantFragmentDoc = gql`
    fragment TopProductVariant on ProductVariant {
  id
  name
  availability
  labels(first: 10) {
    edges {
      node {
        id
        name
        color
        backgroundColor
      }
    }
  }
  media {
    id
    alt
    url(size: 3000)
  }
  translation(languageCode: $languageCode) {
    name
  }
  pricing {
    price {
      net {
        currency
        amount
      }
    }
    percentageDiscountAmount
    priceUndiscounted {
      net {
        currency
        amount
      }
    }
    discount {
      net {
        currency
        amount
      }
    }
    installmentPrice4 {
      currency
      amount
    }
    installmentPrice6 {
      currency
      amount
    }
    installmentPrice12 {
      currency
      amount
    }
    bonusesAmount
  }
  product {
    id
    name
    slug
    category {
      id
      name
      slug
      translation(languageCode: $languageCode) {
        name
      }
    }
  }
}
    `;
export const DiscountRuleDetailsFragmentDoc = gql`
    fragment DiscountRuleDetails on PromotionRule {
  id
  name
  description
  giftIds
  rewardType
  rewardValueType
  rewardValue
  cataloguePredicate
  orderPredicate
}
    `;
export const AccountAddressCreateDocument = gql`
    mutation AccountAddressCreate($input: AddressInput!, $type: AddressTypeEnum) {
  accountAddressCreate(input: $input, type: $type) {
    user {
      ...UserBasic
    }
    address {
      ...AddressBasic
    }
    errors {
      field
      message
    }
  }
}
    ${UserBasicFragmentDoc}
${AddressBasicFragmentDoc}`;
export type AccountAddressCreateMutationFn = Apollo.MutationFunction<Types.AccountAddressCreateMutation, Types.AccountAddressCreateMutationVariables>;

/**
 * __useAccountAddressCreateMutation__
 *
 * To run a mutation, you first call `useAccountAddressCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountAddressCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountAddressCreateMutation, { data, loading, error }] = useAccountAddressCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useAccountAddressCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AccountAddressCreateMutation, Types.AccountAddressCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AccountAddressCreateMutation, Types.AccountAddressCreateMutationVariables>(AccountAddressCreateDocument, options);
      }
export type AccountAddressCreateMutationHookResult = ReturnType<typeof useAccountAddressCreateMutation>;
export type AccountAddressCreateMutationResult = Apollo.MutationResult<Types.AccountAddressCreateMutation>;
export type AccountAddressCreateMutationOptions = Apollo.BaseMutationOptions<Types.AccountAddressCreateMutation, Types.AccountAddressCreateMutationVariables>;
export const AccountAddressDeleteDocument = gql`
    mutation AccountAddressDelete($id: ID!) {
  accountAddressDelete(id: $id) {
    user {
      ...UserBasic
    }
    address {
      ...AddressBasic
    }
    errors {
      field
      message
    }
  }
}
    ${UserBasicFragmentDoc}
${AddressBasicFragmentDoc}`;
export type AccountAddressDeleteMutationFn = Apollo.MutationFunction<Types.AccountAddressDeleteMutation, Types.AccountAddressDeleteMutationVariables>;

/**
 * __useAccountAddressDeleteMutation__
 *
 * To run a mutation, you first call `useAccountAddressDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountAddressDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountAddressDeleteMutation, { data, loading, error }] = useAccountAddressDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAccountAddressDeleteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AccountAddressDeleteMutation, Types.AccountAddressDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AccountAddressDeleteMutation, Types.AccountAddressDeleteMutationVariables>(AccountAddressDeleteDocument, options);
      }
export type AccountAddressDeleteMutationHookResult = ReturnType<typeof useAccountAddressDeleteMutation>;
export type AccountAddressDeleteMutationResult = Apollo.MutationResult<Types.AccountAddressDeleteMutation>;
export type AccountAddressDeleteMutationOptions = Apollo.BaseMutationOptions<Types.AccountAddressDeleteMutation, Types.AccountAddressDeleteMutationVariables>;
export const AccountAddressUpdateDocument = gql`
    mutation AccountAddressUpdate($input: AddressInput!, $id: ID!) {
  accountAddressUpdate(input: $input, id: $id) {
    user {
      ...UserBasic
    }
    address {
      ...AddressBasic
    }
    errors {
      field
      message
    }
  }
}
    ${UserBasicFragmentDoc}
${AddressBasicFragmentDoc}`;
export type AccountAddressUpdateMutationFn = Apollo.MutationFunction<Types.AccountAddressUpdateMutation, Types.AccountAddressUpdateMutationVariables>;

/**
 * __useAccountAddressUpdateMutation__
 *
 * To run a mutation, you first call `useAccountAddressUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountAddressUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountAddressUpdateMutation, { data, loading, error }] = useAccountAddressUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAccountAddressUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AccountAddressUpdateMutation, Types.AccountAddressUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AccountAddressUpdateMutation, Types.AccountAddressUpdateMutationVariables>(AccountAddressUpdateDocument, options);
      }
export type AccountAddressUpdateMutationHookResult = ReturnType<typeof useAccountAddressUpdateMutation>;
export type AccountAddressUpdateMutationResult = Apollo.MutationResult<Types.AccountAddressUpdateMutation>;
export type AccountAddressUpdateMutationOptions = Apollo.BaseMutationOptions<Types.AccountAddressUpdateMutation, Types.AccountAddressUpdateMutationVariables>;
export const OtpAccountDeleteDocument = gql`
    mutation otpAccountDelete($otp: String!) {
  otpAccountDelete(otp: $otp) {
    errors {
      field
      message
    }
    user {
      id
    }
  }
}
    `;
export type OtpAccountDeleteMutationFn = Apollo.MutationFunction<Types.OtpAccountDeleteMutation, Types.OtpAccountDeleteMutationVariables>;

/**
 * __useOtpAccountDeleteMutation__
 *
 * To run a mutation, you first call `useOtpAccountDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOtpAccountDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [otpAccountDeleteMutation, { data, loading, error }] = useOtpAccountDeleteMutation({
 *   variables: {
 *      otp: // value for 'otp'
 *   },
 * });
 */
export function useOtpAccountDeleteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.OtpAccountDeleteMutation, Types.OtpAccountDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.OtpAccountDeleteMutation, Types.OtpAccountDeleteMutationVariables>(OtpAccountDeleteDocument, options);
      }
export type OtpAccountDeleteMutationHookResult = ReturnType<typeof useOtpAccountDeleteMutation>;
export type OtpAccountDeleteMutationResult = Apollo.MutationResult<Types.OtpAccountDeleteMutation>;
export type OtpAccountDeleteMutationOptions = Apollo.BaseMutationOptions<Types.OtpAccountDeleteMutation, Types.OtpAccountDeleteMutationVariables>;
export const AccountSetDefaultAddressDocument = gql`
    mutation accountSetDefaultAddress($type: AddressTypeEnum!, $id: ID!) {
  accountSetDefaultAddress(type: $type, id: $id) {
    user {
      ...UserBasic
    }
    errors {
      field
      message
    }
  }
}
    ${UserBasicFragmentDoc}`;
export type AccountSetDefaultAddressMutationFn = Apollo.MutationFunction<Types.AccountSetDefaultAddressMutation, Types.AccountSetDefaultAddressMutationVariables>;

/**
 * __useAccountSetDefaultAddressMutation__
 *
 * To run a mutation, you first call `useAccountSetDefaultAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountSetDefaultAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountSetDefaultAddressMutation, { data, loading, error }] = useAccountSetDefaultAddressMutation({
 *   variables: {
 *      type: // value for 'type'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAccountSetDefaultAddressMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AccountSetDefaultAddressMutation, Types.AccountSetDefaultAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AccountSetDefaultAddressMutation, Types.AccountSetDefaultAddressMutationVariables>(AccountSetDefaultAddressDocument, options);
      }
export type AccountSetDefaultAddressMutationHookResult = ReturnType<typeof useAccountSetDefaultAddressMutation>;
export type AccountSetDefaultAddressMutationResult = Apollo.MutationResult<Types.AccountSetDefaultAddressMutation>;
export type AccountSetDefaultAddressMutationOptions = Apollo.BaseMutationOptions<Types.AccountSetDefaultAddressMutation, Types.AccountSetDefaultAddressMutationVariables>;
export const OtpAccountUpdateDocument = gql`
    mutation OtpAccountUpdate($otp: String!, $phone: String!, $input: OtpAccountUpdateInput!) {
  otpAccountUpdate(otp: $otp, phone: $phone, input: $input) {
    user {
      ...UserBasic
    }
    errors {
      field
      message
    }
  }
}
    ${UserBasicFragmentDoc}`;
export type OtpAccountUpdateMutationFn = Apollo.MutationFunction<Types.OtpAccountUpdateMutation, Types.OtpAccountUpdateMutationVariables>;

/**
 * __useOtpAccountUpdateMutation__
 *
 * To run a mutation, you first call `useOtpAccountUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOtpAccountUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [otpAccountUpdateMutation, { data, loading, error }] = useOtpAccountUpdateMutation({
 *   variables: {
 *      otp: // value for 'otp'
 *      phone: // value for 'phone'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOtpAccountUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.OtpAccountUpdateMutation, Types.OtpAccountUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.OtpAccountUpdateMutation, Types.OtpAccountUpdateMutationVariables>(OtpAccountUpdateDocument, options);
      }
export type OtpAccountUpdateMutationHookResult = ReturnType<typeof useOtpAccountUpdateMutation>;
export type OtpAccountUpdateMutationResult = Apollo.MutationResult<Types.OtpAccountUpdateMutation>;
export type OtpAccountUpdateMutationOptions = Apollo.BaseMutationOptions<Types.OtpAccountUpdateMutation, Types.OtpAccountUpdateMutationVariables>;
export const ApplicationCreateDocument = gql`
    mutation ApplicationCreate($input: InstallmentApplicationInput!) {
  installmentApplicationCreate(input: $input) {
    installmentApplication {
      ...Applications
    }
    errors {
      field
      message
    }
  }
}
    ${ApplicationsFragmentDoc}`;
export type ApplicationCreateMutationFn = Apollo.MutationFunction<Types.ApplicationCreateMutation, Types.ApplicationCreateMutationVariables>;

/**
 * __useApplicationCreateMutation__
 *
 * To run a mutation, you first call `useApplicationCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplicationCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applicationCreateMutation, { data, loading, error }] = useApplicationCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplicationCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ApplicationCreateMutation, Types.ApplicationCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ApplicationCreateMutation, Types.ApplicationCreateMutationVariables>(ApplicationCreateDocument, options);
      }
export type ApplicationCreateMutationHookResult = ReturnType<typeof useApplicationCreateMutation>;
export type ApplicationCreateMutationResult = Apollo.MutationResult<Types.ApplicationCreateMutation>;
export type ApplicationCreateMutationOptions = Apollo.BaseMutationOptions<Types.ApplicationCreateMutation, Types.ApplicationCreateMutationVariables>;
export const AuthenticateCustomerDocument = gql`
    mutation AuthenticateCustomer($input: AuthenticateCustomerInput!, $phone: String!) {
  authenticateCustomer(input: $input, phone: $phone) {
    errors {
      field
      message
    }
    user {
      id
    }
  }
}
    `;
export type AuthenticateCustomerMutationFn = Apollo.MutationFunction<Types.AuthenticateCustomerMutation, Types.AuthenticateCustomerMutationVariables>;

/**
 * __useAuthenticateCustomerMutation__
 *
 * To run a mutation, you first call `useAuthenticateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateCustomerMutation, { data, loading, error }] = useAuthenticateCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useAuthenticateCustomerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AuthenticateCustomerMutation, Types.AuthenticateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AuthenticateCustomerMutation, Types.AuthenticateCustomerMutationVariables>(AuthenticateCustomerDocument, options);
      }
export type AuthenticateCustomerMutationHookResult = ReturnType<typeof useAuthenticateCustomerMutation>;
export type AuthenticateCustomerMutationResult = Apollo.MutationResult<Types.AuthenticateCustomerMutation>;
export type AuthenticateCustomerMutationOptions = Apollo.BaseMutationOptions<Types.AuthenticateCustomerMutation, Types.AuthenticateCustomerMutationVariables>;
export const CustomerCreateTokenDocument = gql`
    mutation CustomerCreateToken($phone: String!, $audience: String) {
  customerCreateToken(phone: $phone, audience: $audience) {
    token
    refreshToken
    csrfToken
    user {
      ...UserBasic
    }
    errors {
      field
      message
    }
  }
}
    ${UserBasicFragmentDoc}`;
export type CustomerCreateTokenMutationFn = Apollo.MutationFunction<Types.CustomerCreateTokenMutation, Types.CustomerCreateTokenMutationVariables>;

/**
 * __useCustomerCreateTokenMutation__
 *
 * To run a mutation, you first call `useCustomerCreateTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerCreateTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerCreateTokenMutation, { data, loading, error }] = useCustomerCreateTokenMutation({
 *   variables: {
 *      phone: // value for 'phone'
 *      audience: // value for 'audience'
 *   },
 * });
 */
export function useCustomerCreateTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.CustomerCreateTokenMutation, Types.CustomerCreateTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.CustomerCreateTokenMutation, Types.CustomerCreateTokenMutationVariables>(CustomerCreateTokenDocument, options);
      }
export type CustomerCreateTokenMutationHookResult = ReturnType<typeof useCustomerCreateTokenMutation>;
export type CustomerCreateTokenMutationResult = Apollo.MutationResult<Types.CustomerCreateTokenMutation>;
export type CustomerCreateTokenMutationOptions = Apollo.BaseMutationOptions<Types.CustomerCreateTokenMutation, Types.CustomerCreateTokenMutationVariables>;
export const SendOtpDocument = gql`
    mutation SendOTP($phone: String!) {
  sendOtp(phone: $phone) {
    status
    phone
    details
    errors {
      message
      code
      field
    }
  }
}
    `;
export type SendOtpMutationFn = Apollo.MutationFunction<Types.SendOtpMutation, Types.SendOtpMutationVariables>;

/**
 * __useSendOtpMutation__
 *
 * To run a mutation, you first call `useSendOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendOtpMutation, { data, loading, error }] = useSendOtpMutation({
 *   variables: {
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useSendOtpMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SendOtpMutation, Types.SendOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SendOtpMutation, Types.SendOtpMutationVariables>(SendOtpDocument, options);
      }
export type SendOtpMutationHookResult = ReturnType<typeof useSendOtpMutation>;
export type SendOtpMutationResult = Apollo.MutationResult<Types.SendOtpMutation>;
export type SendOtpMutationOptions = Apollo.BaseMutationOptions<Types.SendOtpMutation, Types.SendOtpMutationVariables>;
export const VerifyOtpDocument = gql`
    mutation VerifyOTP($otp: String!, $phone: String!) {
  verifyOtp(otp: $otp, phone: $phone) {
    status
    phone
    errors {
      message
      code
      field
    }
  }
}
    `;
export type VerifyOtpMutationFn = Apollo.MutationFunction<Types.VerifyOtpMutation, Types.VerifyOtpMutationVariables>;

/**
 * __useVerifyOtpMutation__
 *
 * To run a mutation, you first call `useVerifyOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyOtpMutation, { data, loading, error }] = useVerifyOtpMutation({
 *   variables: {
 *      otp: // value for 'otp'
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useVerifyOtpMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.VerifyOtpMutation, Types.VerifyOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.VerifyOtpMutation, Types.VerifyOtpMutationVariables>(VerifyOtpDocument, options);
      }
export type VerifyOtpMutationHookResult = ReturnType<typeof useVerifyOtpMutation>;
export type VerifyOtpMutationResult = Apollo.MutationResult<Types.VerifyOtpMutation>;
export type VerifyOtpMutationOptions = Apollo.BaseMutationOptions<Types.VerifyOtpMutation, Types.VerifyOtpMutationVariables>;
export const TokenRefreshDocument = gql`
    mutation TokenRefresh($csrfToken: String, $refreshToken: String!) {
  tokenRefresh(csrfToken: $csrfToken, refreshToken: $refreshToken) {
    token
    user {
      ...UserBasic
    }
    errors {
      message
    }
  }
}
    ${UserBasicFragmentDoc}`;
export type TokenRefreshMutationFn = Apollo.MutationFunction<Types.TokenRefreshMutation, Types.TokenRefreshMutationVariables>;

/**
 * __useTokenRefreshMutation__
 *
 * To run a mutation, you first call `useTokenRefreshMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTokenRefreshMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tokenRefreshMutation, { data, loading, error }] = useTokenRefreshMutation({
 *   variables: {
 *      csrfToken: // value for 'csrfToken'
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useTokenRefreshMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.TokenRefreshMutation, Types.TokenRefreshMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.TokenRefreshMutation, Types.TokenRefreshMutationVariables>(TokenRefreshDocument, options);
      }
export type TokenRefreshMutationHookResult = ReturnType<typeof useTokenRefreshMutation>;
export type TokenRefreshMutationResult = Apollo.MutationResult<Types.TokenRefreshMutation>;
export type TokenRefreshMutationOptions = Apollo.BaseMutationOptions<Types.TokenRefreshMutation, Types.TokenRefreshMutationVariables>;
export const OrderApplyBonusesDocument = gql`
    mutation OrderApplyBonuses($id: ID!, $amount: PositiveDecimal!) {
  orderApplyBonuses(id: $id, amount: $amount) {
    order {
      ...OrderBasic
    }
    errors {
      field
      message
    }
  }
}
    ${OrderBasicFragmentDoc}`;
export type OrderApplyBonusesMutationFn = Apollo.MutationFunction<Types.OrderApplyBonusesMutation, Types.OrderApplyBonusesMutationVariables>;

/**
 * __useOrderApplyBonusesMutation__
 *
 * To run a mutation, you first call `useOrderApplyBonusesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderApplyBonusesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderApplyBonusesMutation, { data, loading, error }] = useOrderApplyBonusesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      amount: // value for 'amount'
 *   },
 * });
 */
export function useOrderApplyBonusesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.OrderApplyBonusesMutation, Types.OrderApplyBonusesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.OrderApplyBonusesMutation, Types.OrderApplyBonusesMutationVariables>(OrderApplyBonusesDocument, options);
      }
export type OrderApplyBonusesMutationHookResult = ReturnType<typeof useOrderApplyBonusesMutation>;
export type OrderApplyBonusesMutationResult = Apollo.MutationResult<Types.OrderApplyBonusesMutation>;
export type OrderApplyBonusesMutationOptions = Apollo.BaseMutationOptions<Types.OrderApplyBonusesMutation, Types.OrderApplyBonusesMutationVariables>;
export const OrderCancelBonusesDocument = gql`
    mutation orderCancelBonuses($id: ID!) {
  orderCancelBonuses(id: $id) {
    order {
      ...OrderBasic
    }
    errors {
      field
      message
    }
  }
}
    ${OrderBasicFragmentDoc}`;
export type OrderCancelBonusesMutationFn = Apollo.MutationFunction<Types.OrderCancelBonusesMutation, Types.OrderCancelBonusesMutationVariables>;

/**
 * __useOrderCancelBonusesMutation__
 *
 * To run a mutation, you first call `useOrderCancelBonusesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderCancelBonusesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderCancelBonusesMutation, { data, loading, error }] = useOrderCancelBonusesMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrderCancelBonusesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.OrderCancelBonusesMutation, Types.OrderCancelBonusesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.OrderCancelBonusesMutation, Types.OrderCancelBonusesMutationVariables>(OrderCancelBonusesDocument, options);
      }
export type OrderCancelBonusesMutationHookResult = ReturnType<typeof useOrderCancelBonusesMutation>;
export type OrderCancelBonusesMutationResult = Apollo.MutationResult<Types.OrderCancelBonusesMutation>;
export type OrderCancelBonusesMutationOptions = Apollo.BaseMutationOptions<Types.OrderCancelBonusesMutation, Types.OrderCancelBonusesMutationVariables>;
export const CheckoutLinesAddDocument = gql`
    mutation CheckoutLinesAdd($id: ID!, $lines: [CheckoutLineInput!]!) {
  checkoutLinesAdd(id: $id, lines: $lines) {
    checkout {
      id
      lines {
        id
        quantity
        totalPrice {
          net {
            currency
            amount
          }
        }
        variant {
          id
          name
        }
      }
    }
    errors {
      field
      message
    }
  }
}
    `;
export type CheckoutLinesAddMutationFn = Apollo.MutationFunction<Types.CheckoutLinesAddMutation, Types.CheckoutLinesAddMutationVariables>;

/**
 * __useCheckoutLinesAddMutation__
 *
 * To run a mutation, you first call `useCheckoutLinesAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutLinesAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutLinesAddMutation, { data, loading, error }] = useCheckoutLinesAddMutation({
 *   variables: {
 *      id: // value for 'id'
 *      lines: // value for 'lines'
 *   },
 * });
 */
export function useCheckoutLinesAddMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.CheckoutLinesAddMutation, Types.CheckoutLinesAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.CheckoutLinesAddMutation, Types.CheckoutLinesAddMutationVariables>(CheckoutLinesAddDocument, options);
      }
export type CheckoutLinesAddMutationHookResult = ReturnType<typeof useCheckoutLinesAddMutation>;
export type CheckoutLinesAddMutationResult = Apollo.MutationResult<Types.CheckoutLinesAddMutation>;
export type CheckoutLinesAddMutationOptions = Apollo.BaseMutationOptions<Types.CheckoutLinesAddMutation, Types.CheckoutLinesAddMutationVariables>;
export const CheckoutLinesDeleteDocument = gql`
    mutation checkoutLinesDelete($id: ID!, $linesIds: [ID!]!) {
  checkoutLinesDelete(id: $id, linesIds: $linesIds) {
    checkout {
      id
    }
    errors {
      field
      message
    }
  }
}
    `;
export type CheckoutLinesDeleteMutationFn = Apollo.MutationFunction<Types.CheckoutLinesDeleteMutation, Types.CheckoutLinesDeleteMutationVariables>;

/**
 * __useCheckoutLinesDeleteMutation__
 *
 * To run a mutation, you first call `useCheckoutLinesDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutLinesDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutLinesDeleteMutation, { data, loading, error }] = useCheckoutLinesDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      linesIds: // value for 'linesIds'
 *   },
 * });
 */
export function useCheckoutLinesDeleteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.CheckoutLinesDeleteMutation, Types.CheckoutLinesDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.CheckoutLinesDeleteMutation, Types.CheckoutLinesDeleteMutationVariables>(CheckoutLinesDeleteDocument, options);
      }
export type CheckoutLinesDeleteMutationHookResult = ReturnType<typeof useCheckoutLinesDeleteMutation>;
export type CheckoutLinesDeleteMutationResult = Apollo.MutationResult<Types.CheckoutLinesDeleteMutation>;
export type CheckoutLinesDeleteMutationOptions = Apollo.BaseMutationOptions<Types.CheckoutLinesDeleteMutation, Types.CheckoutLinesDeleteMutationVariables>;
export const AddFavoriteDocument = gql`
    mutation AddFavorite($variant: ID!) {
  addFavorite(variant: $variant) {
    user {
      favorites(first: 100) {
        edges {
          node {
            ...ProductVariantBasic
          }
        }
      }
    }
    errors {
      field
      message
    }
  }
}
    ${ProductVariantBasicFragmentDoc}`;
export type AddFavoriteMutationFn = Apollo.MutationFunction<Types.AddFavoriteMutation, Types.AddFavoriteMutationVariables>;

/**
 * __useAddFavoriteMutation__
 *
 * To run a mutation, you first call `useAddFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFavoriteMutation, { data, loading, error }] = useAddFavoriteMutation({
 *   variables: {
 *      variant: // value for 'variant'
 *   },
 * });
 */
export function useAddFavoriteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AddFavoriteMutation, Types.AddFavoriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AddFavoriteMutation, Types.AddFavoriteMutationVariables>(AddFavoriteDocument, options);
      }
export type AddFavoriteMutationHookResult = ReturnType<typeof useAddFavoriteMutation>;
export type AddFavoriteMutationResult = Apollo.MutationResult<Types.AddFavoriteMutation>;
export type AddFavoriteMutationOptions = Apollo.BaseMutationOptions<Types.AddFavoriteMutation, Types.AddFavoriteMutationVariables>;
export const ClearFavoritesDocument = gql`
    mutation ClearFavorites {
  clearFavorites {
    user {
      favorites(first: 100) {
        edges {
          node {
            ...ProductVariantBasic
          }
        }
      }
    }
    errors {
      field
      message
    }
  }
}
    ${ProductVariantBasicFragmentDoc}`;
export type ClearFavoritesMutationFn = Apollo.MutationFunction<Types.ClearFavoritesMutation, Types.ClearFavoritesMutationVariables>;

/**
 * __useClearFavoritesMutation__
 *
 * To run a mutation, you first call `useClearFavoritesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearFavoritesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearFavoritesMutation, { data, loading, error }] = useClearFavoritesMutation({
 *   variables: {
 *   },
 * });
 */
export function useClearFavoritesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ClearFavoritesMutation, Types.ClearFavoritesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ClearFavoritesMutation, Types.ClearFavoritesMutationVariables>(ClearFavoritesDocument, options);
      }
export type ClearFavoritesMutationHookResult = ReturnType<typeof useClearFavoritesMutation>;
export type ClearFavoritesMutationResult = Apollo.MutationResult<Types.ClearFavoritesMutation>;
export type ClearFavoritesMutationOptions = Apollo.BaseMutationOptions<Types.ClearFavoritesMutation, Types.ClearFavoritesMutationVariables>;
export const RemoveFavoriteDocument = gql`
    mutation RemoveFavorite($variant: ID!) {
  removeFavorite(variant: $variant) {
    user {
      favorites(first: 100) {
        edges {
          node {
            ...ProductVariantBasic
          }
        }
      }
    }
    errors {
      field
      message
    }
  }
}
    ${ProductVariantBasicFragmentDoc}`;
export type RemoveFavoriteMutationFn = Apollo.MutationFunction<Types.RemoveFavoriteMutation, Types.RemoveFavoriteMutationVariables>;

/**
 * __useRemoveFavoriteMutation__
 *
 * To run a mutation, you first call `useRemoveFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFavoriteMutation, { data, loading, error }] = useRemoveFavoriteMutation({
 *   variables: {
 *      variant: // value for 'variant'
 *   },
 * });
 */
export function useRemoveFavoriteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.RemoveFavoriteMutation, Types.RemoveFavoriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.RemoveFavoriteMutation, Types.RemoveFavoriteMutationVariables>(RemoveFavoriteDocument, options);
      }
export type RemoveFavoriteMutationHookResult = ReturnType<typeof useRemoveFavoriteMutation>;
export type RemoveFavoriteMutationResult = Apollo.MutationResult<Types.RemoveFavoriteMutation>;
export type RemoveFavoriteMutationOptions = Apollo.BaseMutationOptions<Types.RemoveFavoriteMutation, Types.RemoveFavoriteMutationVariables>;
export const AddVariantToComparisonDocument = gql`
    mutation AddVariantToComparison($variant: ID!) {
  addVariantToComparison(variant: $variant) {
    user {
      comparison {
        ...ProductVariantBasic
      }
    }
    errors {
      field
      message
    }
  }
}
    ${ProductVariantBasicFragmentDoc}`;
export type AddVariantToComparisonMutationFn = Apollo.MutationFunction<Types.AddVariantToComparisonMutation, Types.AddVariantToComparisonMutationVariables>;

/**
 * __useAddVariantToComparisonMutation__
 *
 * To run a mutation, you first call `useAddVariantToComparisonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddVariantToComparisonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addVariantToComparisonMutation, { data, loading, error }] = useAddVariantToComparisonMutation({
 *   variables: {
 *      variant: // value for 'variant'
 *   },
 * });
 */
export function useAddVariantToComparisonMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AddVariantToComparisonMutation, Types.AddVariantToComparisonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AddVariantToComparisonMutation, Types.AddVariantToComparisonMutationVariables>(AddVariantToComparisonDocument, options);
      }
export type AddVariantToComparisonMutationHookResult = ReturnType<typeof useAddVariantToComparisonMutation>;
export type AddVariantToComparisonMutationResult = Apollo.MutationResult<Types.AddVariantToComparisonMutation>;
export type AddVariantToComparisonMutationOptions = Apollo.BaseMutationOptions<Types.AddVariantToComparisonMutation, Types.AddVariantToComparisonMutationVariables>;
export const RemoveVariantFromComparisonDocument = gql`
    mutation RemoveVariantFromComparison($variant: ID!) {
  removeVariantFromComparison(variant: $variant) {
    user {
      comparison {
        ...ProductVariantBasic
      }
    }
    errors {
      field
      message
    }
  }
}
    ${ProductVariantBasicFragmentDoc}`;
export type RemoveVariantFromComparisonMutationFn = Apollo.MutationFunction<Types.RemoveVariantFromComparisonMutation, Types.RemoveVariantFromComparisonMutationVariables>;

/**
 * __useRemoveVariantFromComparisonMutation__
 *
 * To run a mutation, you first call `useRemoveVariantFromComparisonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveVariantFromComparisonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeVariantFromComparisonMutation, { data, loading, error }] = useRemoveVariantFromComparisonMutation({
 *   variables: {
 *      variant: // value for 'variant'
 *   },
 * });
 */
export function useRemoveVariantFromComparisonMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.RemoveVariantFromComparisonMutation, Types.RemoveVariantFromComparisonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.RemoveVariantFromComparisonMutation, Types.RemoveVariantFromComparisonMutationVariables>(RemoveVariantFromComparisonDocument, options);
      }
export type RemoveVariantFromComparisonMutationHookResult = ReturnType<typeof useRemoveVariantFromComparisonMutation>;
export type RemoveVariantFromComparisonMutationResult = Apollo.MutationResult<Types.RemoveVariantFromComparisonMutation>;
export type RemoveVariantFromComparisonMutationOptions = Apollo.BaseMutationOptions<Types.RemoveVariantFromComparisonMutation, Types.RemoveVariantFromComparisonMutationVariables>;
export const ClearComparisonDocument = gql`
    mutation ClearComparison($ids: [ID!]!) {
  clearComparison(ids: $ids) {
    user {
      comparison {
        ...ProductVariantBasic
      }
    }
    errors {
      field
      message
    }
  }
}
    ${ProductVariantBasicFragmentDoc}`;
export type ClearComparisonMutationFn = Apollo.MutationFunction<Types.ClearComparisonMutation, Types.ClearComparisonMutationVariables>;

/**
 * __useClearComparisonMutation__
 *
 * To run a mutation, you first call `useClearComparisonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearComparisonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearComparisonMutation, { data, loading, error }] = useClearComparisonMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useClearComparisonMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ClearComparisonMutation, Types.ClearComparisonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ClearComparisonMutation, Types.ClearComparisonMutationVariables>(ClearComparisonDocument, options);
      }
export type ClearComparisonMutationHookResult = ReturnType<typeof useClearComparisonMutation>;
export type ClearComparisonMutationResult = Apollo.MutationResult<Types.ClearComparisonMutation>;
export type ClearComparisonMutationOptions = Apollo.BaseMutationOptions<Types.ClearComparisonMutation, Types.ClearComparisonMutationVariables>;
export const AddViewedVariantDocument = gql`
    mutation AddViewedVariant($variant: ID!) {
  addViewedVariant(variant: $variant) {
    user {
      viewedVariants(first: 100) {
        edges {
          node {
            ...ProductVariantBasic
          }
        }
      }
    }
    errors {
      field
      message
    }
  }
}
    ${ProductVariantBasicFragmentDoc}`;
export type AddViewedVariantMutationFn = Apollo.MutationFunction<Types.AddViewedVariantMutation, Types.AddViewedVariantMutationVariables>;

/**
 * __useAddViewedVariantMutation__
 *
 * To run a mutation, you first call `useAddViewedVariantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddViewedVariantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addViewedVariantMutation, { data, loading, error }] = useAddViewedVariantMutation({
 *   variables: {
 *      variant: // value for 'variant'
 *   },
 * });
 */
export function useAddViewedVariantMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AddViewedVariantMutation, Types.AddViewedVariantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AddViewedVariantMutation, Types.AddViewedVariantMutationVariables>(AddViewedVariantDocument, options);
      }
export type AddViewedVariantMutationHookResult = ReturnType<typeof useAddViewedVariantMutation>;
export type AddViewedVariantMutationResult = Apollo.MutationResult<Types.AddViewedVariantMutation>;
export type AddViewedVariantMutationOptions = Apollo.BaseMutationOptions<Types.AddViewedVariantMutation, Types.AddViewedVariantMutationVariables>;
export const RemoveViewedVariantDocument = gql`
    mutation RemoveViewedVariant($variant: ID!) {
  removeViewedVariant(variant: $variant) {
    user {
      viewedVariants(first: 100) {
        edges {
          node {
            ...ProductVariantBasic
          }
        }
      }
    }
    errors {
      field
      message
    }
  }
}
    ${ProductVariantBasicFragmentDoc}`;
export type RemoveViewedVariantMutationFn = Apollo.MutationFunction<Types.RemoveViewedVariantMutation, Types.RemoveViewedVariantMutationVariables>;

/**
 * __useRemoveViewedVariantMutation__
 *
 * To run a mutation, you first call `useRemoveViewedVariantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveViewedVariantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeViewedVariantMutation, { data, loading, error }] = useRemoveViewedVariantMutation({
 *   variables: {
 *      variant: // value for 'variant'
 *   },
 * });
 */
export function useRemoveViewedVariantMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.RemoveViewedVariantMutation, Types.RemoveViewedVariantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.RemoveViewedVariantMutation, Types.RemoveViewedVariantMutationVariables>(RemoveViewedVariantDocument, options);
      }
export type RemoveViewedVariantMutationHookResult = ReturnType<typeof useRemoveViewedVariantMutation>;
export type RemoveViewedVariantMutationResult = Apollo.MutationResult<Types.RemoveViewedVariantMutation>;
export type RemoveViewedVariantMutationOptions = Apollo.BaseMutationOptions<Types.RemoveViewedVariantMutation, Types.RemoveViewedVariantMutationVariables>;
export const ClearViewedVariantsDocument = gql`
    mutation ClearViewedVariants {
  clearViewedVariants {
    user {
      viewedVariants(first: 100) {
        edges {
          node {
            ...ProductVariantBasic
          }
        }
      }
    }
    errors {
      field
      message
    }
  }
}
    ${ProductVariantBasicFragmentDoc}`;
export type ClearViewedVariantsMutationFn = Apollo.MutationFunction<Types.ClearViewedVariantsMutation, Types.ClearViewedVariantsMutationVariables>;

/**
 * __useClearViewedVariantsMutation__
 *
 * To run a mutation, you first call `useClearViewedVariantsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearViewedVariantsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearViewedVariantsMutation, { data, loading, error }] = useClearViewedVariantsMutation({
 *   variables: {
 *   },
 * });
 */
export function useClearViewedVariantsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ClearViewedVariantsMutation, Types.ClearViewedVariantsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ClearViewedVariantsMutation, Types.ClearViewedVariantsMutationVariables>(ClearViewedVariantsDocument, options);
      }
export type ClearViewedVariantsMutationHookResult = ReturnType<typeof useClearViewedVariantsMutation>;
export type ClearViewedVariantsMutationResult = Apollo.MutationResult<Types.ClearViewedVariantsMutation>;
export type ClearViewedVariantsMutationOptions = Apollo.BaseMutationOptions<Types.ClearViewedVariantsMutation, Types.ClearViewedVariantsMutationVariables>;
export const DraftOrderCompleteDocument = gql`
    mutation DraftOrderComplete($id: ID!, $withIman: Boolean = false) {
  draftOrderComplete(id: $id, withIman: $withIman) {
    order {
      ...OrderBasic
    }
    imanData {
      qrCode
      deepLink
      qrDeepLink
    }
    errors {
      field
      message
    }
  }
}
    ${OrderBasicFragmentDoc}`;
export type DraftOrderCompleteMutationFn = Apollo.MutationFunction<Types.DraftOrderCompleteMutation, Types.DraftOrderCompleteMutationVariables>;

/**
 * __useDraftOrderCompleteMutation__
 *
 * To run a mutation, you first call `useDraftOrderCompleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDraftOrderCompleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [draftOrderCompleteMutation, { data, loading, error }] = useDraftOrderCompleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withIman: // value for 'withIman'
 *   },
 * });
 */
export function useDraftOrderCompleteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.DraftOrderCompleteMutation, Types.DraftOrderCompleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.DraftOrderCompleteMutation, Types.DraftOrderCompleteMutationVariables>(DraftOrderCompleteDocument, options);
      }
export type DraftOrderCompleteMutationHookResult = ReturnType<typeof useDraftOrderCompleteMutation>;
export type DraftOrderCompleteMutationResult = Apollo.MutationResult<Types.DraftOrderCompleteMutation>;
export type DraftOrderCompleteMutationOptions = Apollo.BaseMutationOptions<Types.DraftOrderCompleteMutation, Types.DraftOrderCompleteMutationVariables>;
export const DraftOrderUpdateDocument = gql`
    mutation DraftOrderUpdate($id: ID, $input: DraftOrderInput!) {
  draftOrderUpdate(id: $id, input: $input) {
    order {
      ...OrderBasic
    }
    errors {
      field
      message
    }
  }
}
    ${OrderBasicFragmentDoc}`;
export type DraftOrderUpdateMutationFn = Apollo.MutationFunction<Types.DraftOrderUpdateMutation, Types.DraftOrderUpdateMutationVariables>;

/**
 * __useDraftOrderUpdateMutation__
 *
 * To run a mutation, you first call `useDraftOrderUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDraftOrderUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [draftOrderUpdateMutation, { data, loading, error }] = useDraftOrderUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDraftOrderUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.DraftOrderUpdateMutation, Types.DraftOrderUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.DraftOrderUpdateMutation, Types.DraftOrderUpdateMutationVariables>(DraftOrderUpdateDocument, options);
      }
export type DraftOrderUpdateMutationHookResult = ReturnType<typeof useDraftOrderUpdateMutation>;
export type DraftOrderUpdateMutationResult = Apollo.MutationResult<Types.DraftOrderUpdateMutation>;
export type DraftOrderUpdateMutationOptions = Apollo.BaseMutationOptions<Types.DraftOrderUpdateMutation, Types.DraftOrderUpdateMutationVariables>;
export const DraftOrderCreateDocument = gql`
    mutation DraftOrderCreate($input: DraftOrderCreateInput!) {
  draftOrderCreate(input: $input) {
    order {
      ...OrderFragment
    }
    errors {
      field
      message
    }
  }
}
    ${OrderFragmentFragmentDoc}`;
export type DraftOrderCreateMutationFn = Apollo.MutationFunction<Types.DraftOrderCreateMutation, Types.DraftOrderCreateMutationVariables>;

/**
 * __useDraftOrderCreateMutation__
 *
 * To run a mutation, you first call `useDraftOrderCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDraftOrderCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [draftOrderCreateMutation, { data, loading, error }] = useDraftOrderCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDraftOrderCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.DraftOrderCreateMutation, Types.DraftOrderCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.DraftOrderCreateMutation, Types.DraftOrderCreateMutationVariables>(DraftOrderCreateDocument, options);
      }
export type DraftOrderCreateMutationHookResult = ReturnType<typeof useDraftOrderCreateMutation>;
export type DraftOrderCreateMutationResult = Apollo.MutationResult<Types.DraftOrderCreateMutation>;
export type DraftOrderCreateMutationOptions = Apollo.BaseMutationOptions<Types.DraftOrderCreateMutation, Types.DraftOrderCreateMutationVariables>;
export const DraftOrderDeleteDocument = gql`
    mutation DraftOrderDelete($id: ID) {
  draftOrderDelete(id: $id) {
    order {
      ...OrderFragment
    }
    errors {
      field
      message
    }
  }
}
    ${OrderFragmentFragmentDoc}`;
export type DraftOrderDeleteMutationFn = Apollo.MutationFunction<Types.DraftOrderDeleteMutation, Types.DraftOrderDeleteMutationVariables>;

/**
 * __useDraftOrderDeleteMutation__
 *
 * To run a mutation, you first call `useDraftOrderDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDraftOrderDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [draftOrderDeleteMutation, { data, loading, error }] = useDraftOrderDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDraftOrderDeleteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.DraftOrderDeleteMutation, Types.DraftOrderDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.DraftOrderDeleteMutation, Types.DraftOrderDeleteMutationVariables>(DraftOrderDeleteDocument, options);
      }
export type DraftOrderDeleteMutationHookResult = ReturnType<typeof useDraftOrderDeleteMutation>;
export type DraftOrderDeleteMutationResult = Apollo.MutationResult<Types.DraftOrderDeleteMutation>;
export type DraftOrderDeleteMutationOptions = Apollo.BaseMutationOptions<Types.DraftOrderDeleteMutation, Types.DraftOrderDeleteMutationVariables>;
export const OrderCancelDocument = gql`
    mutation OrderCancel($id: ID!) {
  orderCancel(id: $id) {
    errors {
      field
      message
    }
  }
}
    `;
export type OrderCancelMutationFn = Apollo.MutationFunction<Types.OrderCancelMutation, Types.OrderCancelMutationVariables>;

/**
 * __useOrderCancelMutation__
 *
 * To run a mutation, you first call `useOrderCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderCancelMutation, { data, loading, error }] = useOrderCancelMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrderCancelMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.OrderCancelMutation, Types.OrderCancelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.OrderCancelMutation, Types.OrderCancelMutationVariables>(OrderCancelDocument, options);
      }
export type OrderCancelMutationHookResult = ReturnType<typeof useOrderCancelMutation>;
export type OrderCancelMutationResult = Apollo.MutationResult<Types.OrderCancelMutation>;
export type OrderCancelMutationOptions = Apollo.BaseMutationOptions<Types.OrderCancelMutation, Types.OrderCancelMutationVariables>;
export const DraftOrderLineDeleteDocument = gql`
    mutation DraftOrderLineDelete($id: ID!) {
  orderLineDelete(id: $id) {
    order {
      ...OrderFragment
    }
    errors {
      field
      message
    }
  }
}
    ${OrderFragmentFragmentDoc}`;
export type DraftOrderLineDeleteMutationFn = Apollo.MutationFunction<Types.DraftOrderLineDeleteMutation, Types.DraftOrderLineDeleteMutationVariables>;

/**
 * __useDraftOrderLineDeleteMutation__
 *
 * To run a mutation, you first call `useDraftOrderLineDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDraftOrderLineDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [draftOrderLineDeleteMutation, { data, loading, error }] = useDraftOrderLineDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDraftOrderLineDeleteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.DraftOrderLineDeleteMutation, Types.DraftOrderLineDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.DraftOrderLineDeleteMutation, Types.DraftOrderLineDeleteMutationVariables>(DraftOrderLineDeleteDocument, options);
      }
export type DraftOrderLineDeleteMutationHookResult = ReturnType<typeof useDraftOrderLineDeleteMutation>;
export type DraftOrderLineDeleteMutationResult = Apollo.MutationResult<Types.DraftOrderLineDeleteMutation>;
export type DraftOrderLineDeleteMutationOptions = Apollo.BaseMutationOptions<Types.DraftOrderLineDeleteMutation, Types.DraftOrderLineDeleteMutationVariables>;
export const OrderLineUpdateDocument = gql`
    mutation OrderLineUpdate($id: ID!, $input: OrderLineInput!) {
  orderLineUpdate(id: $id, input: $input) {
    order {
      ...OrderFragment
    }
    errors {
      field
      message
    }
  }
}
    ${OrderFragmentFragmentDoc}`;
export type OrderLineUpdateMutationFn = Apollo.MutationFunction<Types.OrderLineUpdateMutation, Types.OrderLineUpdateMutationVariables>;

/**
 * __useOrderLineUpdateMutation__
 *
 * To run a mutation, you first call `useOrderLineUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderLineUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderLineUpdateMutation, { data, loading, error }] = useOrderLineUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrderLineUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.OrderLineUpdateMutation, Types.OrderLineUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.OrderLineUpdateMutation, Types.OrderLineUpdateMutationVariables>(OrderLineUpdateDocument, options);
      }
export type OrderLineUpdateMutationHookResult = ReturnType<typeof useOrderLineUpdateMutation>;
export type OrderLineUpdateMutationResult = Apollo.MutationResult<Types.OrderLineUpdateMutation>;
export type OrderLineUpdateMutationOptions = Apollo.BaseMutationOptions<Types.OrderLineUpdateMutation, Types.OrderLineUpdateMutationVariables>;
export const DraftOrderLineCreateDocument = gql`
    mutation DraftOrderLineCreate($id: ID!, $input: [OrderLineCreateInput!]!) {
  orderLinesCreate(id: $id, input: $input) {
    order {
      ...OrderFragment
    }
    errors {
      field
      message
    }
  }
}
    ${OrderFragmentFragmentDoc}`;
export type DraftOrderLineCreateMutationFn = Apollo.MutationFunction<Types.DraftOrderLineCreateMutation, Types.DraftOrderLineCreateMutationVariables>;

/**
 * __useDraftOrderLineCreateMutation__
 *
 * To run a mutation, you first call `useDraftOrderLineCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDraftOrderLineCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [draftOrderLineCreateMutation, { data, loading, error }] = useDraftOrderLineCreateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDraftOrderLineCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.DraftOrderLineCreateMutation, Types.DraftOrderLineCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.DraftOrderLineCreateMutation, Types.DraftOrderLineCreateMutationVariables>(DraftOrderLineCreateDocument, options);
      }
export type DraftOrderLineCreateMutationHookResult = ReturnType<typeof useDraftOrderLineCreateMutation>;
export type DraftOrderLineCreateMutationResult = Apollo.MutationResult<Types.DraftOrderLineCreateMutation>;
export type DraftOrderLineCreateMutationOptions = Apollo.BaseMutationOptions<Types.DraftOrderLineCreateMutation, Types.DraftOrderLineCreateMutationVariables>;
export const OrderClickPaymentUrlDocument = gql`
    mutation OrderClickPaymentUrl($id: ID!, $amount: PositiveDecimal!, $returnUrl: String) {
  orderClickPaymentUrl(id: $id, amount: $amount, returnUrl: $returnUrl) {
    redirectUrl
    errors {
      field
      message
    }
  }
}
    `;
export type OrderClickPaymentUrlMutationFn = Apollo.MutationFunction<Types.OrderClickPaymentUrlMutation, Types.OrderClickPaymentUrlMutationVariables>;

/**
 * __useOrderClickPaymentUrlMutation__
 *
 * To run a mutation, you first call `useOrderClickPaymentUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderClickPaymentUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderClickPaymentUrlMutation, { data, loading, error }] = useOrderClickPaymentUrlMutation({
 *   variables: {
 *      id: // value for 'id'
 *      amount: // value for 'amount'
 *      returnUrl: // value for 'returnUrl'
 *   },
 * });
 */
export function useOrderClickPaymentUrlMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.OrderClickPaymentUrlMutation, Types.OrderClickPaymentUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.OrderClickPaymentUrlMutation, Types.OrderClickPaymentUrlMutationVariables>(OrderClickPaymentUrlDocument, options);
      }
export type OrderClickPaymentUrlMutationHookResult = ReturnType<typeof useOrderClickPaymentUrlMutation>;
export type OrderClickPaymentUrlMutationResult = Apollo.MutationResult<Types.OrderClickPaymentUrlMutation>;
export type OrderClickPaymentUrlMutationOptions = Apollo.BaseMutationOptions<Types.OrderClickPaymentUrlMutation, Types.OrderClickPaymentUrlMutationVariables>;
export const OrderFreedomPayInitDocument = gql`
    mutation OrderFreedomPayInit($id: ID!, $amount: PositiveDecimal!, $successUrl: String, $failureUrl: String) {
  orderFreedomPayInit(
    id: $id
    amount: $amount
    successUrl: $successUrl
    failureUrl: $failureUrl
  ) {
    status
    paymentId
    redirectUrl
    errors {
      field
      message
    }
  }
}
    `;
export type OrderFreedomPayInitMutationFn = Apollo.MutationFunction<Types.OrderFreedomPayInitMutation, Types.OrderFreedomPayInitMutationVariables>;

/**
 * __useOrderFreedomPayInitMutation__
 *
 * To run a mutation, you first call `useOrderFreedomPayInitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderFreedomPayInitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderFreedomPayInitMutation, { data, loading, error }] = useOrderFreedomPayInitMutation({
 *   variables: {
 *      id: // value for 'id'
 *      amount: // value for 'amount'
 *      successUrl: // value for 'successUrl'
 *      failureUrl: // value for 'failureUrl'
 *   },
 * });
 */
export function useOrderFreedomPayInitMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.OrderFreedomPayInitMutation, Types.OrderFreedomPayInitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.OrderFreedomPayInitMutation, Types.OrderFreedomPayInitMutationVariables>(OrderFreedomPayInitDocument, options);
      }
export type OrderFreedomPayInitMutationHookResult = ReturnType<typeof useOrderFreedomPayInitMutation>;
export type OrderFreedomPayInitMutationResult = Apollo.MutationResult<Types.OrderFreedomPayInitMutation>;
export type OrderFreedomPayInitMutationOptions = Apollo.BaseMutationOptions<Types.OrderFreedomPayInitMutation, Types.OrderFreedomPayInitMutationVariables>;
export const ReviewCreateDocument = gql`
    mutation ReviewCreate($input: ReviewInput!) {
  reviewCreate(input: $input) {
    review {
      ...ReviewBasic
    }
    errors {
      field
      message
    }
  }
}
    ${ReviewBasicFragmentDoc}`;
export type ReviewCreateMutationFn = Apollo.MutationFunction<Types.ReviewCreateMutation, Types.ReviewCreateMutationVariables>;

/**
 * __useReviewCreateMutation__
 *
 * To run a mutation, you first call `useReviewCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewCreateMutation, { data, loading, error }] = useReviewCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReviewCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ReviewCreateMutation, Types.ReviewCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ReviewCreateMutation, Types.ReviewCreateMutationVariables>(ReviewCreateDocument, options);
      }
export type ReviewCreateMutationHookResult = ReturnType<typeof useReviewCreateMutation>;
export type ReviewCreateMutationResult = Apollo.MutationResult<Types.ReviewCreateMutation>;
export type ReviewCreateMutationOptions = Apollo.BaseMutationOptions<Types.ReviewCreateMutation, Types.ReviewCreateMutationVariables>;
export const UserAvatarUpdateDocument = gql`
    mutation UserAvatarUpdate($image: Upload!) {
  userAvatarUpdate(image: $image) {
    user {
      ...UserBasic
    }
  }
}
    ${UserBasicFragmentDoc}`;
export type UserAvatarUpdateMutationFn = Apollo.MutationFunction<Types.UserAvatarUpdateMutation, Types.UserAvatarUpdateMutationVariables>;

/**
 * __useUserAvatarUpdateMutation__
 *
 * To run a mutation, you first call `useUserAvatarUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserAvatarUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userAvatarUpdateMutation, { data, loading, error }] = useUserAvatarUpdateMutation({
 *   variables: {
 *      image: // value for 'image'
 *   },
 * });
 */
export function useUserAvatarUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.UserAvatarUpdateMutation, Types.UserAvatarUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.UserAvatarUpdateMutation, Types.UserAvatarUpdateMutationVariables>(UserAvatarUpdateDocument, options);
      }
export type UserAvatarUpdateMutationHookResult = ReturnType<typeof useUserAvatarUpdateMutation>;
export type UserAvatarUpdateMutationResult = Apollo.MutationResult<Types.UserAvatarUpdateMutation>;
export type UserAvatarUpdateMutationOptions = Apollo.BaseMutationOptions<Types.UserAvatarUpdateMutation, Types.UserAvatarUpdateMutationVariables>;
export const OrderUzumNasiyaCheckStatusDocument = gql`
    mutation OrderUzumNasiyaCheckStatus($phone: String!) {
  orderUzumNasiyaCheckStatus(phone: $phone) {
    result {
      status
      error {
        type
        text
        subText
      }
      data {
        webview
        status
        buyerId
        availablePeriods {
          period
          titleUz
          titleRu
          availableBalance
        }
      }
    }
    errors {
      field
      message
      code
    }
  }
}
    `;
export type OrderUzumNasiyaCheckStatusMutationFn = Apollo.MutationFunction<Types.OrderUzumNasiyaCheckStatusMutation, Types.OrderUzumNasiyaCheckStatusMutationVariables>;

/**
 * __useOrderUzumNasiyaCheckStatusMutation__
 *
 * To run a mutation, you first call `useOrderUzumNasiyaCheckStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderUzumNasiyaCheckStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderUzumNasiyaCheckStatusMutation, { data, loading, error }] = useOrderUzumNasiyaCheckStatusMutation({
 *   variables: {
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useOrderUzumNasiyaCheckStatusMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.OrderUzumNasiyaCheckStatusMutation, Types.OrderUzumNasiyaCheckStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.OrderUzumNasiyaCheckStatusMutation, Types.OrderUzumNasiyaCheckStatusMutationVariables>(OrderUzumNasiyaCheckStatusDocument, options);
      }
export type OrderUzumNasiyaCheckStatusMutationHookResult = ReturnType<typeof useOrderUzumNasiyaCheckStatusMutation>;
export type OrderUzumNasiyaCheckStatusMutationResult = Apollo.MutationResult<Types.OrderUzumNasiyaCheckStatusMutation>;
export type OrderUzumNasiyaCheckStatusMutationOptions = Apollo.BaseMutationOptions<Types.OrderUzumNasiyaCheckStatusMutation, Types.OrderUzumNasiyaCheckStatusMutationVariables>;
export const VacancyResponseCreateDocument = gql`
    mutation VacancyResponseCreate($input: VacancyResponseInput!) {
  vacancyResponseCreate(input: $input) {
    vacancyResponse {
      id
      name
      surname
      contactPhone
      vacancy {
        ...VacancyFragment
      }
    }
    errors {
      field
      message
    }
  }
}
    ${VacancyFragmentFragmentDoc}`;
export type VacancyResponseCreateMutationFn = Apollo.MutationFunction<Types.VacancyResponseCreateMutation, Types.VacancyResponseCreateMutationVariables>;

/**
 * __useVacancyResponseCreateMutation__
 *
 * To run a mutation, you first call `useVacancyResponseCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVacancyResponseCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vacancyResponseCreateMutation, { data, loading, error }] = useVacancyResponseCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVacancyResponseCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.VacancyResponseCreateMutation, Types.VacancyResponseCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.VacancyResponseCreateMutation, Types.VacancyResponseCreateMutationVariables>(VacancyResponseCreateDocument, options);
      }
export type VacancyResponseCreateMutationHookResult = ReturnType<typeof useVacancyResponseCreateMutation>;
export type VacancyResponseCreateMutationResult = Apollo.MutationResult<Types.VacancyResponseCreateMutation>;
export type VacancyResponseCreateMutationOptions = Apollo.BaseMutationOptions<Types.VacancyResponseCreateMutation, Types.VacancyResponseCreateMutationVariables>;
export const ResumeCreateDocument = gql`
    mutation ResumeCreate($input: ResumeCreateInput!) {
  resumeCreate(input: $input) {
    resume {
      id
      name
      surname
      contactPhone
      direction
      desiredPosition
      file1
      file2
      note
    }
    errors {
      field
      message
    }
  }
}
    `;
export type ResumeCreateMutationFn = Apollo.MutationFunction<Types.ResumeCreateMutation, Types.ResumeCreateMutationVariables>;

/**
 * __useResumeCreateMutation__
 *
 * To run a mutation, you first call `useResumeCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeCreateMutation, { data, loading, error }] = useResumeCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResumeCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ResumeCreateMutation, Types.ResumeCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ResumeCreateMutation, Types.ResumeCreateMutationVariables>(ResumeCreateDocument, options);
      }
export type ResumeCreateMutationHookResult = ReturnType<typeof useResumeCreateMutation>;
export type ResumeCreateMutationResult = Apollo.MutationResult<Types.ResumeCreateMutation>;
export type ResumeCreateMutationOptions = Apollo.BaseMutationOptions<Types.ResumeCreateMutation, Types.ResumeCreateMutationVariables>;
export const VacanciesListDocument = gql`
    query VacanciesList($first: Int, $last: Int, $after: String, $before: String, $filter: VacancyFilterInput) {
  vacancies(
    before: $before
    after: $after
    first: $first
    last: $last
    filter: $filter
  ) {
    edges {
      node {
        ...VacancyFragment
      }
    }
    totalCount
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
  }
}
    ${VacancyFragmentFragmentDoc}`;

/**
 * __useVacanciesListQuery__
 *
 * To run a query within a React component, call `useVacanciesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useVacanciesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVacanciesListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useVacanciesListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.VacanciesListQuery, Types.VacanciesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.VacanciesListQuery, Types.VacanciesListQueryVariables>(VacanciesListDocument, options);
      }
export function useVacanciesListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.VacanciesListQuery, Types.VacanciesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.VacanciesListQuery, Types.VacanciesListQueryVariables>(VacanciesListDocument, options);
        }
export function useVacanciesListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.VacanciesListQuery, Types.VacanciesListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.VacanciesListQuery, Types.VacanciesListQueryVariables>(VacanciesListDocument, options);
        }
export type VacanciesListQueryHookResult = ReturnType<typeof useVacanciesListQuery>;
export type VacanciesListLazyQueryHookResult = ReturnType<typeof useVacanciesListLazyQuery>;
export type VacanciesListSuspenseQueryHookResult = ReturnType<typeof useVacanciesListSuspenseQuery>;
export type VacanciesListQueryResult = Apollo.QueryResult<Types.VacanciesListQuery, Types.VacanciesListQueryVariables>;
export const ApplicationsListDocument = gql`
    query ApplicationsList($first: Int, $after: String, $last: Int, $before: String, $filter: InstallmentApplicationFilterInput) {
  installmentApplications(
    first: $first
    after: $after
    last: $last
    before: $before
    filter: $filter
  ) {
    edges {
      node {
        ...Applications
      }
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${ApplicationsFragmentDoc}`;

/**
 * __useApplicationsListQuery__
 *
 * To run a query within a React component, call `useApplicationsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationsListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useApplicationsListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ApplicationsListQuery, Types.ApplicationsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ApplicationsListQuery, Types.ApplicationsListQueryVariables>(ApplicationsListDocument, options);
      }
export function useApplicationsListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ApplicationsListQuery, Types.ApplicationsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ApplicationsListQuery, Types.ApplicationsListQueryVariables>(ApplicationsListDocument, options);
        }
export function useApplicationsListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ApplicationsListQuery, Types.ApplicationsListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ApplicationsListQuery, Types.ApplicationsListQueryVariables>(ApplicationsListDocument, options);
        }
export type ApplicationsListQueryHookResult = ReturnType<typeof useApplicationsListQuery>;
export type ApplicationsListLazyQueryHookResult = ReturnType<typeof useApplicationsListLazyQuery>;
export type ApplicationsListSuspenseQueryHookResult = ReturnType<typeof useApplicationsListSuspenseQuery>;
export type ApplicationsListQueryResult = Apollo.QueryResult<Types.ApplicationsListQuery, Types.ApplicationsListQueryVariables>;
export const AttributesCategoriesDocument = gql`
    query AttributesCategories($first: Int, $after: String, $filter: AttributeFilterInput, $attributesCategoriesFilter: AttributeCategoryFilterInput, $where: AttributeWhereInput, $languageCode: LanguageCodeEnum!) {
  attributesCategories(
    first: $first
    after: $after
    filter: $attributesCategoriesFilter
  ) {
    edges {
      node {
        id
        name
        translation(languageCode: $languageCode) {
          name
        }
        description
        attributes(first: 10, filter: $filter, where: $where) {
          edges {
            node {
              id
              slug
              name
              type
              unit
              withChoices
              inputType
              translation(languageCode: $languageCode) {
                name
              }
              category {
                id
                name
                description
                translation(languageCode: $languageCode) {
                  name
                }
              }
              choices(first: 10) {
                edges {
                  node {
                    id
                    name
                    translation(languageCode: $languageCode) {
                      name
                    }
                    value
                    slug
                  }
                }
              }
            }
          }
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useAttributesCategoriesQuery__
 *
 * To run a query within a React component, call `useAttributesCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributesCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributesCategoriesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      attributesCategoriesFilter: // value for 'attributesCategoriesFilter'
 *      where: // value for 'where'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useAttributesCategoriesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AttributesCategoriesQuery, Types.AttributesCategoriesQueryVariables> & ({ variables: Types.AttributesCategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AttributesCategoriesQuery, Types.AttributesCategoriesQueryVariables>(AttributesCategoriesDocument, options);
      }
export function useAttributesCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AttributesCategoriesQuery, Types.AttributesCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AttributesCategoriesQuery, Types.AttributesCategoriesQueryVariables>(AttributesCategoriesDocument, options);
        }
export function useAttributesCategoriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AttributesCategoriesQuery, Types.AttributesCategoriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AttributesCategoriesQuery, Types.AttributesCategoriesQueryVariables>(AttributesCategoriesDocument, options);
        }
export type AttributesCategoriesQueryHookResult = ReturnType<typeof useAttributesCategoriesQuery>;
export type AttributesCategoriesLazyQueryHookResult = ReturnType<typeof useAttributesCategoriesLazyQuery>;
export type AttributesCategoriesSuspenseQueryHookResult = ReturnType<typeof useAttributesCategoriesSuspenseQuery>;
export type AttributesCategoriesQueryResult = Apollo.QueryResult<Types.AttributesCategoriesQuery, Types.AttributesCategoriesQueryVariables>;
export const BannerListDocument = gql`
    query BannerList($first: Int, $after: String, $filter: BannerFilterInput) {
  banners(first: $first, after: $after, filter: $filter) {
    edges {
      node {
        ...BannerBasic
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
  }
}
    ${BannerBasicFragmentDoc}`;

/**
 * __useBannerListQuery__
 *
 * To run a query within a React component, call `useBannerListQuery` and pass it any options that fit your needs.
 * When your component renders, `useBannerListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBannerListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useBannerListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.BannerListQuery, Types.BannerListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.BannerListQuery, Types.BannerListQueryVariables>(BannerListDocument, options);
      }
export function useBannerListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.BannerListQuery, Types.BannerListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.BannerListQuery, Types.BannerListQueryVariables>(BannerListDocument, options);
        }
export function useBannerListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.BannerListQuery, Types.BannerListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.BannerListQuery, Types.BannerListQueryVariables>(BannerListDocument, options);
        }
export type BannerListQueryHookResult = ReturnType<typeof useBannerListQuery>;
export type BannerListLazyQueryHookResult = ReturnType<typeof useBannerListLazyQuery>;
export type BannerListSuspenseQueryHookResult = ReturnType<typeof useBannerListSuspenseQuery>;
export type BannerListQueryResult = Apollo.QueryResult<Types.BannerListQuery, Types.BannerListQueryVariables>;
export const BrandListDocument = gql`
    query BrandList($first: Int, $after: String, $filter: BrandFilterInput, $forCategory: ID, $languageCode: LanguageCodeEnum!) {
  brands(first: $first, after: $after, filter: $filter, forCategory: $forCategory) {
    edges {
      node {
        ...BrandBasic
        translation(languageCode: $languageCode) {
          name
        }
        sidebarCategories(first: $first) {
          edges {
            node {
              id
              name
              seoTitle
            }
          }
        }
      }
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${BrandBasicFragmentDoc}`;

/**
 * __useBrandListQuery__
 *
 * To run a query within a React component, call `useBrandListQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      forCategory: // value for 'forCategory'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useBrandListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.BrandListQuery, Types.BrandListQueryVariables> & ({ variables: Types.BrandListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.BrandListQuery, Types.BrandListQueryVariables>(BrandListDocument, options);
      }
export function useBrandListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.BrandListQuery, Types.BrandListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.BrandListQuery, Types.BrandListQueryVariables>(BrandListDocument, options);
        }
export function useBrandListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.BrandListQuery, Types.BrandListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.BrandListQuery, Types.BrandListQueryVariables>(BrandListDocument, options);
        }
export type BrandListQueryHookResult = ReturnType<typeof useBrandListQuery>;
export type BrandListLazyQueryHookResult = ReturnType<typeof useBrandListLazyQuery>;
export type BrandListSuspenseQueryHookResult = ReturnType<typeof useBrandListSuspenseQuery>;
export type BrandListQueryResult = Apollo.QueryResult<Types.BrandListQuery, Types.BrandListQueryVariables>;
export const CategoryListDocument = gql`
    query CategoryList($first: Int, $after: String, $level: Int, $filter: CategoryFilterInput, $productFilter: ProductFilterInput, $languageCode: LanguageCodeEnum!, $childrenFilter: CategoryFilterInput, $sortBy: CategorySortingInput) {
  categories(
    first: $first
    after: $after
    level: $level
    filter: $filter
    sortBy: $sortBy
  ) {
    edges {
      node {
        id
        name
        slug
        description
        icon
        level
        isActive
        isInCatalog
        isBottom
        isPopular
        translation(languageCode: $languageCode) {
          name
        }
        products(first: 1, filter: $productFilter) {
          totalCount
        }
        parent {
          id
          name
          slug
          icon
          level
          isActive
          isInCatalog
          isPopular
          isBottom
          products(first: 1, filter: $productFilter) {
            totalCount
          }
        }
        children(first: 100, filter: $childrenFilter) {
          edges {
            node {
              id
              name
              slug
            }
          }
        }
        translation(languageCode: $languageCode) {
          name
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useCategoryListQuery__
 *
 * To run a query within a React component, call `useCategoryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      level: // value for 'level'
 *      filter: // value for 'filter'
 *      productFilter: // value for 'productFilter'
 *      languageCode: // value for 'languageCode'
 *      childrenFilter: // value for 'childrenFilter'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useCategoryListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CategoryListQuery, Types.CategoryListQueryVariables> & ({ variables: Types.CategoryListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CategoryListQuery, Types.CategoryListQueryVariables>(CategoryListDocument, options);
      }
export function useCategoryListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CategoryListQuery, Types.CategoryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CategoryListQuery, Types.CategoryListQueryVariables>(CategoryListDocument, options);
        }
export function useCategoryListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CategoryListQuery, Types.CategoryListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CategoryListQuery, Types.CategoryListQueryVariables>(CategoryListDocument, options);
        }
export type CategoryListQueryHookResult = ReturnType<typeof useCategoryListQuery>;
export type CategoryListLazyQueryHookResult = ReturnType<typeof useCategoryListLazyQuery>;
export type CategoryListSuspenseQueryHookResult = ReturnType<typeof useCategoryListSuspenseQuery>;
export type CategoryListQueryResult = Apollo.QueryResult<Types.CategoryListQuery, Types.CategoryListQueryVariables>;
export const CategoryDocument = gql`
    query Category($id: ID, $slug: String, $slugLanguageCode: LanguageCodeEnum, $productFilter: ProductFilterInput, $productWhere: ProductWhereInput, $first: Int, $similarProductsFilter: ProductFilterInput, $languageCode: LanguageCodeEnum!) {
  category(id: $id, slug: $slug, slugLanguageCode: $slugLanguageCode) {
    id
    name
    slug
    description
    icon
    level
    isActive
    isInCatalog
    isBottom
    isPopular
    seoTitle
    metaDescription
    metaKeywords
    translation(languageCode: $languageCode) {
      name
    }
    parent {
      id
      name
      slug
      icon
      level
      isActive
      isInCatalog
      isPopular
      isBottom
    }
    ancestors(first: 10) {
      edges {
        node {
          id
          name
          slug
          level
          translation(languageCode: $languageCode) {
            name
          }
        }
      }
    }
    children(first: $first) {
      edges {
        node {
          id
          name
          slug
          translation(languageCode: $languageCode) {
            name
          }
        }
      }
    }
    products(first: $first, filter: $productFilter, where: $productWhere) {
      edges {
        node {
          ...ProductBasic
          translation(languageCode: $languageCode) {
            name
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
}
    ${ProductBasicFragmentDoc}`;

/**
 * __useCategoryQuery__
 *
 * To run a query within a React component, call `useCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      slug: // value for 'slug'
 *      slugLanguageCode: // value for 'slugLanguageCode'
 *      productFilter: // value for 'productFilter'
 *      productWhere: // value for 'productWhere'
 *      first: // value for 'first'
 *      similarProductsFilter: // value for 'similarProductsFilter'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useCategoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CategoryQuery, Types.CategoryQueryVariables> & ({ variables: Types.CategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CategoryQuery, Types.CategoryQueryVariables>(CategoryDocument, options);
      }
export function useCategoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CategoryQuery, Types.CategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CategoryQuery, Types.CategoryQueryVariables>(CategoryDocument, options);
        }
export function useCategorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CategoryQuery, Types.CategoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CategoryQuery, Types.CategoryQueryVariables>(CategoryDocument, options);
        }
export type CategoryQueryHookResult = ReturnType<typeof useCategoryQuery>;
export type CategoryLazyQueryHookResult = ReturnType<typeof useCategoryLazyQuery>;
export type CategorySuspenseQueryHookResult = ReturnType<typeof useCategorySuspenseQuery>;
export type CategoryQueryResult = Apollo.QueryResult<Types.CategoryQuery, Types.CategoryQueryVariables>;
export const CategorySeoDocument = gql`
    query CategorySEO($id: ID, $languageCode: LanguageCodeEnum!) {
  category(id: $id) {
    id
    name
    slug
    description
    icon
    level
    isActive
    isInCatalog
    isBottom
    isPopular
    seoTitle
    metaDescription
    metaKeywords
    translation(languageCode: $languageCode) {
      name
    }
  }
}
    `;

/**
 * __useCategorySeoQuery__
 *
 * To run a query within a React component, call `useCategorySeoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategorySeoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategorySeoQuery({
 *   variables: {
 *      id: // value for 'id'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useCategorySeoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CategorySeoQuery, Types.CategorySeoQueryVariables> & ({ variables: Types.CategorySeoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CategorySeoQuery, Types.CategorySeoQueryVariables>(CategorySeoDocument, options);
      }
export function useCategorySeoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CategorySeoQuery, Types.CategorySeoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CategorySeoQuery, Types.CategorySeoQueryVariables>(CategorySeoDocument, options);
        }
export function useCategorySeoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CategorySeoQuery, Types.CategorySeoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CategorySeoQuery, Types.CategorySeoQueryVariables>(CategorySeoDocument, options);
        }
export type CategorySeoQueryHookResult = ReturnType<typeof useCategorySeoQuery>;
export type CategorySeoLazyQueryHookResult = ReturnType<typeof useCategorySeoLazyQuery>;
export type CategorySeoSuspenseQueryHookResult = ReturnType<typeof useCategorySeoSuspenseQuery>;
export type CategorySeoQueryResult = Apollo.QueryResult<Types.CategorySeoQuery, Types.CategorySeoQueryVariables>;
export const CategoryListWithNestedChildrenDocument = gql`
    query CategoryListWithNestedChildren($first: Int, $after: String, $level: Int, $filter: CategoryFilterInput, $languageCode: LanguageCodeEnum!) {
  categories(first: $first, after: $after, level: $level, filter: $filter) {
    edges {
      node {
        ...CategoryWithNestedChildren
        translation(languageCode: $languageCode) {
          name
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${CategoryWithNestedChildrenFragmentDoc}`;

/**
 * __useCategoryListWithNestedChildrenQuery__
 *
 * To run a query within a React component, call `useCategoryListWithNestedChildrenQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryListWithNestedChildrenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryListWithNestedChildrenQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      level: // value for 'level'
 *      filter: // value for 'filter'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useCategoryListWithNestedChildrenQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CategoryListWithNestedChildrenQuery, Types.CategoryListWithNestedChildrenQueryVariables> & ({ variables: Types.CategoryListWithNestedChildrenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CategoryListWithNestedChildrenQuery, Types.CategoryListWithNestedChildrenQueryVariables>(CategoryListWithNestedChildrenDocument, options);
      }
export function useCategoryListWithNestedChildrenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CategoryListWithNestedChildrenQuery, Types.CategoryListWithNestedChildrenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CategoryListWithNestedChildrenQuery, Types.CategoryListWithNestedChildrenQueryVariables>(CategoryListWithNestedChildrenDocument, options);
        }
export function useCategoryListWithNestedChildrenSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CategoryListWithNestedChildrenQuery, Types.CategoryListWithNestedChildrenQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CategoryListWithNestedChildrenQuery, Types.CategoryListWithNestedChildrenQueryVariables>(CategoryListWithNestedChildrenDocument, options);
        }
export type CategoryListWithNestedChildrenQueryHookResult = ReturnType<typeof useCategoryListWithNestedChildrenQuery>;
export type CategoryListWithNestedChildrenLazyQueryHookResult = ReturnType<typeof useCategoryListWithNestedChildrenLazyQuery>;
export type CategoryListWithNestedChildrenSuspenseQueryHookResult = ReturnType<typeof useCategoryListWithNestedChildrenSuspenseQuery>;
export type CategoryListWithNestedChildrenQueryResult = Apollo.QueryResult<Types.CategoryListWithNestedChildrenQuery, Types.CategoryListWithNestedChildrenQueryVariables>;
export const CategoryListWithNestedChildrenSortByDocument = gql`
    query CategoryListWithNestedChildrenSortBy($first: Int, $after: String, $level: Int, $filter: CategoryFilterInput, $productSortBy: ProductOrder, $languageCode: LanguageCodeEnum!) {
  categories(first: $first, after: $after, level: $level, filter: $filter) {
    edges {
      node {
        ...CategoryWithNestedChildrenSortBy
        translation(languageCode: $languageCode) {
          name
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${CategoryWithNestedChildrenSortByFragmentDoc}`;

/**
 * __useCategoryListWithNestedChildrenSortByQuery__
 *
 * To run a query within a React component, call `useCategoryListWithNestedChildrenSortByQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryListWithNestedChildrenSortByQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryListWithNestedChildrenSortByQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      level: // value for 'level'
 *      filter: // value for 'filter'
 *      productSortBy: // value for 'productSortBy'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useCategoryListWithNestedChildrenSortByQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CategoryListWithNestedChildrenSortByQuery, Types.CategoryListWithNestedChildrenSortByQueryVariables> & ({ variables: Types.CategoryListWithNestedChildrenSortByQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CategoryListWithNestedChildrenSortByQuery, Types.CategoryListWithNestedChildrenSortByQueryVariables>(CategoryListWithNestedChildrenSortByDocument, options);
      }
export function useCategoryListWithNestedChildrenSortByLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CategoryListWithNestedChildrenSortByQuery, Types.CategoryListWithNestedChildrenSortByQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CategoryListWithNestedChildrenSortByQuery, Types.CategoryListWithNestedChildrenSortByQueryVariables>(CategoryListWithNestedChildrenSortByDocument, options);
        }
export function useCategoryListWithNestedChildrenSortBySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CategoryListWithNestedChildrenSortByQuery, Types.CategoryListWithNestedChildrenSortByQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CategoryListWithNestedChildrenSortByQuery, Types.CategoryListWithNestedChildrenSortByQueryVariables>(CategoryListWithNestedChildrenSortByDocument, options);
        }
export type CategoryListWithNestedChildrenSortByQueryHookResult = ReturnType<typeof useCategoryListWithNestedChildrenSortByQuery>;
export type CategoryListWithNestedChildrenSortByLazyQueryHookResult = ReturnType<typeof useCategoryListWithNestedChildrenSortByLazyQuery>;
export type CategoryListWithNestedChildrenSortBySuspenseQueryHookResult = ReturnType<typeof useCategoryListWithNestedChildrenSortBySuspenseQuery>;
export type CategoryListWithNestedChildrenSortByQueryResult = Apollo.QueryResult<Types.CategoryListWithNestedChildrenSortByQuery, Types.CategoryListWithNestedChildrenSortByQueryVariables>;
export const PopularCategoriesDocument = gql`
    query PopularCategories($first: Int, $after: String, $last: Int, $before: String, $filter: PopularCategoryFilterInput, $languageCode: LanguageCodeEnum!) {
  popularCategories(
    first: $first
    after: $after
    last: $last
    before: $before
    filter: $filter
  ) {
    edges {
      node {
        id
        category {
          ...CategoryBasic
          translation(languageCode: $languageCode) {
            name
          }
        }
        activeFrom
        activeUntil
      }
      cursor
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    ${CategoryBasicFragmentDoc}`;

/**
 * __usePopularCategoriesQuery__
 *
 * To run a query within a React component, call `usePopularCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePopularCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePopularCategoriesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function usePopularCategoriesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.PopularCategoriesQuery, Types.PopularCategoriesQueryVariables> & ({ variables: Types.PopularCategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.PopularCategoriesQuery, Types.PopularCategoriesQueryVariables>(PopularCategoriesDocument, options);
      }
export function usePopularCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.PopularCategoriesQuery, Types.PopularCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.PopularCategoriesQuery, Types.PopularCategoriesQueryVariables>(PopularCategoriesDocument, options);
        }
export function usePopularCategoriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.PopularCategoriesQuery, Types.PopularCategoriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.PopularCategoriesQuery, Types.PopularCategoriesQueryVariables>(PopularCategoriesDocument, options);
        }
export type PopularCategoriesQueryHookResult = ReturnType<typeof usePopularCategoriesQuery>;
export type PopularCategoriesLazyQueryHookResult = ReturnType<typeof usePopularCategoriesLazyQuery>;
export type PopularCategoriesSuspenseQueryHookResult = ReturnType<typeof usePopularCategoriesSuspenseQuery>;
export type PopularCategoriesQueryResult = Apollo.QueryResult<Types.PopularCategoriesQuery, Types.PopularCategoriesQueryVariables>;
export const PromotionCategoriesDocument = gql`
    query PromotionCategories {
  promotionCategories {
    ...CategoryBasic
  }
}
    ${CategoryBasicFragmentDoc}`;

/**
 * __usePromotionCategoriesQuery__
 *
 * To run a query within a React component, call `usePromotionCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePromotionCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePromotionCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePromotionCategoriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.PromotionCategoriesQuery, Types.PromotionCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.PromotionCategoriesQuery, Types.PromotionCategoriesQueryVariables>(PromotionCategoriesDocument, options);
      }
export function usePromotionCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.PromotionCategoriesQuery, Types.PromotionCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.PromotionCategoriesQuery, Types.PromotionCategoriesQueryVariables>(PromotionCategoriesDocument, options);
        }
export function usePromotionCategoriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.PromotionCategoriesQuery, Types.PromotionCategoriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.PromotionCategoriesQuery, Types.PromotionCategoriesQueryVariables>(PromotionCategoriesDocument, options);
        }
export type PromotionCategoriesQueryHookResult = ReturnType<typeof usePromotionCategoriesQuery>;
export type PromotionCategoriesLazyQueryHookResult = ReturnType<typeof usePromotionCategoriesLazyQuery>;
export type PromotionCategoriesSuspenseQueryHookResult = ReturnType<typeof usePromotionCategoriesSuspenseQuery>;
export type PromotionCategoriesQueryResult = Apollo.QueryResult<Types.PromotionCategoriesQuery, Types.PromotionCategoriesQueryVariables>;
export const TopProductCategoriesDocument = gql`
    query TopProductCategories($first: Int, $after: String, $last: Int, $before: String, $level: Int, $sortBy: CategorySortingInput, $languageCode: LanguageCodeEnum!, $brand: ID, $productFilter: ProductFilterInput) {
  topProductCategories(
    first: $first
    after: $after
    last: $last
    before: $before
    level: $level
    sortBy: $sortBy
    brand: $brand
  ) {
    edges {
      node {
        ...CategoryBasic
        translation(languageCode: $languageCode) {
          name
        }
        products(first: 1, filter: $productFilter) {
          totalCount
        }
      }
      cursor
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    ${CategoryBasicFragmentDoc}`;

/**
 * __useTopProductCategoriesQuery__
 *
 * To run a query within a React component, call `useTopProductCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopProductCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopProductCategoriesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      level: // value for 'level'
 *      sortBy: // value for 'sortBy'
 *      languageCode: // value for 'languageCode'
 *      brand: // value for 'brand'
 *      productFilter: // value for 'productFilter'
 *   },
 * });
 */
export function useTopProductCategoriesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.TopProductCategoriesQuery, Types.TopProductCategoriesQueryVariables> & ({ variables: Types.TopProductCategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.TopProductCategoriesQuery, Types.TopProductCategoriesQueryVariables>(TopProductCategoriesDocument, options);
      }
export function useTopProductCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.TopProductCategoriesQuery, Types.TopProductCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.TopProductCategoriesQuery, Types.TopProductCategoriesQueryVariables>(TopProductCategoriesDocument, options);
        }
export function useTopProductCategoriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.TopProductCategoriesQuery, Types.TopProductCategoriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.TopProductCategoriesQuery, Types.TopProductCategoriesQueryVariables>(TopProductCategoriesDocument, options);
        }
export type TopProductCategoriesQueryHookResult = ReturnType<typeof useTopProductCategoriesQuery>;
export type TopProductCategoriesLazyQueryHookResult = ReturnType<typeof useTopProductCategoriesLazyQuery>;
export type TopProductCategoriesSuspenseQueryHookResult = ReturnType<typeof useTopProductCategoriesSuspenseQuery>;
export type TopProductCategoriesQueryResult = Apollo.QueryResult<Types.TopProductCategoriesQuery, Types.TopProductCategoriesQueryVariables>;
export const DefaultChannelDocument = gql`
    query DefaultChannel {
  channel(slug: "default-channel") {
    id
  }
}
    `;

/**
 * __useDefaultChannelQuery__
 *
 * To run a query within a React component, call `useDefaultChannelQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefaultChannelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefaultChannelQuery({
 *   variables: {
 *   },
 * });
 */
export function useDefaultChannelQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.DefaultChannelQuery, Types.DefaultChannelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.DefaultChannelQuery, Types.DefaultChannelQueryVariables>(DefaultChannelDocument, options);
      }
export function useDefaultChannelLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.DefaultChannelQuery, Types.DefaultChannelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.DefaultChannelQuery, Types.DefaultChannelQueryVariables>(DefaultChannelDocument, options);
        }
export function useDefaultChannelSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.DefaultChannelQuery, Types.DefaultChannelQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.DefaultChannelQuery, Types.DefaultChannelQueryVariables>(DefaultChannelDocument, options);
        }
export type DefaultChannelQueryHookResult = ReturnType<typeof useDefaultChannelQuery>;
export type DefaultChannelLazyQueryHookResult = ReturnType<typeof useDefaultChannelLazyQuery>;
export type DefaultChannelSuspenseQueryHookResult = ReturnType<typeof useDefaultChannelSuspenseQuery>;
export type DefaultChannelQueryResult = Apollo.QueryResult<Types.DefaultChannelQuery, Types.DefaultChannelQueryVariables>;
export const CityShippingMethodsListDocument = gql`
    query CityShippingMethodsList($first: Int, $after: String, $filter: CityShippingMethodFilterInput) {
  cityShippingMethods(first: $first, after: $after, filter: $filter) {
    edges {
      node {
        ...CityShippingMethodsBasic
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
  }
}
    ${CityShippingMethodsBasicFragmentDoc}`;

/**
 * __useCityShippingMethodsListQuery__
 *
 * To run a query within a React component, call `useCityShippingMethodsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCityShippingMethodsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCityShippingMethodsListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCityShippingMethodsListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.CityShippingMethodsListQuery, Types.CityShippingMethodsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CityShippingMethodsListQuery, Types.CityShippingMethodsListQueryVariables>(CityShippingMethodsListDocument, options);
      }
export function useCityShippingMethodsListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CityShippingMethodsListQuery, Types.CityShippingMethodsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CityShippingMethodsListQuery, Types.CityShippingMethodsListQueryVariables>(CityShippingMethodsListDocument, options);
        }
export function useCityShippingMethodsListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CityShippingMethodsListQuery, Types.CityShippingMethodsListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CityShippingMethodsListQuery, Types.CityShippingMethodsListQueryVariables>(CityShippingMethodsListDocument, options);
        }
export type CityShippingMethodsListQueryHookResult = ReturnType<typeof useCityShippingMethodsListQuery>;
export type CityShippingMethodsListLazyQueryHookResult = ReturnType<typeof useCityShippingMethodsListLazyQuery>;
export type CityShippingMethodsListSuspenseQueryHookResult = ReturnType<typeof useCityShippingMethodsListSuspenseQuery>;
export type CityShippingMethodsListQueryResult = Apollo.QueryResult<Types.CityShippingMethodsListQuery, Types.CityShippingMethodsListQueryVariables>;
export const CollectionListDocument = gql`
    query CollectionList($first: Int, $filter: CollectionFilterInput, $sort: CollectionSortingInput) {
  collections(first: $first, filter: $filter, sortBy: $sort) {
    edges {
      node {
        ...CollectionDetails
      }
    }
    totalCount
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${CollectionDetailsFragmentDoc}`;

/**
 * __useCollectionListQuery__
 *
 * To run a query within a React component, call `useCollectionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useCollectionListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.CollectionListQuery, Types.CollectionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CollectionListQuery, Types.CollectionListQueryVariables>(CollectionListDocument, options);
      }
export function useCollectionListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CollectionListQuery, Types.CollectionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CollectionListQuery, Types.CollectionListQueryVariables>(CollectionListDocument, options);
        }
export function useCollectionListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CollectionListQuery, Types.CollectionListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CollectionListQuery, Types.CollectionListQueryVariables>(CollectionListDocument, options);
        }
export type CollectionListQueryHookResult = ReturnType<typeof useCollectionListQuery>;
export type CollectionListLazyQueryHookResult = ReturnType<typeof useCollectionListLazyQuery>;
export type CollectionListSuspenseQueryHookResult = ReturnType<typeof useCollectionListSuspenseQuery>;
export type CollectionListQueryResult = Apollo.QueryResult<Types.CollectionListQuery, Types.CollectionListQueryVariables>;
export const CollectionDetailsDocument = gql`
    query CollectionDetails($id: ID!, $first: Int, $after: String, $last: Int, $before: String, $filter: ProductVariantFilterInput, $where: ProductVariantWhereInput, $sortBy: ProductVariantSortingInput, $languageCode: LanguageCodeEnum!) {
  collection(id: $id) {
    ...CollectionDetails
    productVariants(
      first: $first
      after: $after
      before: $before
      last: $last
      filter: $filter
      where: $where
      sortBy: $sortBy
    ) {
      edges {
        node {
          ...CollectiontVariant
        }
      }
      totalCount
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
}
    ${CollectionDetailsFragmentDoc}
${CollectiontVariantFragmentDoc}`;

/**
 * __useCollectionDetailsQuery__
 *
 * To run a query within a React component, call `useCollectionDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *      where: // value for 'where'
 *      sortBy: // value for 'sortBy'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useCollectionDetailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CollectionDetailsQuery, Types.CollectionDetailsQueryVariables> & ({ variables: Types.CollectionDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CollectionDetailsQuery, Types.CollectionDetailsQueryVariables>(CollectionDetailsDocument, options);
      }
export function useCollectionDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CollectionDetailsQuery, Types.CollectionDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CollectionDetailsQuery, Types.CollectionDetailsQueryVariables>(CollectionDetailsDocument, options);
        }
export function useCollectionDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CollectionDetailsQuery, Types.CollectionDetailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CollectionDetailsQuery, Types.CollectionDetailsQueryVariables>(CollectionDetailsDocument, options);
        }
export type CollectionDetailsQueryHookResult = ReturnType<typeof useCollectionDetailsQuery>;
export type CollectionDetailsLazyQueryHookResult = ReturnType<typeof useCollectionDetailsLazyQuery>;
export type CollectionDetailsSuspenseQueryHookResult = ReturnType<typeof useCollectionDetailsSuspenseQuery>;
export type CollectionDetailsQueryResult = Apollo.QueryResult<Types.CollectionDetailsQuery, Types.CollectionDetailsQueryVariables>;
export const PageListDocument = gql`
    query PageList($first: Int, $after: String, $last: Int, $before: String, $sort: PageSortingInput, $filter: PageFilterInput) {
  pages(
    before: $before
    after: $after
    first: $first
    last: $last
    sortBy: $sort
    filter: $filter
  ) {
    edges {
      node {
        id
        title
        slug
        isActive
        description
        image
        innerImage
        isActive
        createdAt
        section
        pageType {
          id
          name
        }
        section
        pageFormat
      }
    }
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __usePageListQuery__
 *
 * To run a query within a React component, call `usePageListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePageListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.PageListQuery, Types.PageListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.PageListQuery, Types.PageListQueryVariables>(PageListDocument, options);
      }
export function usePageListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.PageListQuery, Types.PageListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.PageListQuery, Types.PageListQueryVariables>(PageListDocument, options);
        }
export function usePageListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.PageListQuery, Types.PageListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.PageListQuery, Types.PageListQueryVariables>(PageListDocument, options);
        }
export type PageListQueryHookResult = ReturnType<typeof usePageListQuery>;
export type PageListLazyQueryHookResult = ReturnType<typeof usePageListLazyQuery>;
export type PageListSuspenseQueryHookResult = ReturnType<typeof usePageListSuspenseQuery>;
export type PageListQueryResult = Apollo.QueryResult<Types.PageListQuery, Types.PageListQueryVariables>;
export const PageDetailsDocument = gql`
    query PageDetails($id: ID!) {
  page(id: $id) {
    ...Content
  }
}
    ${ContentFragmentDoc}`;

/**
 * __usePageDetailsQuery__
 *
 * To run a query within a React component, call `usePageDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePageDetailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.PageDetailsQuery, Types.PageDetailsQueryVariables> & ({ variables: Types.PageDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.PageDetailsQuery, Types.PageDetailsQueryVariables>(PageDetailsDocument, options);
      }
export function usePageDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.PageDetailsQuery, Types.PageDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.PageDetailsQuery, Types.PageDetailsQueryVariables>(PageDetailsDocument, options);
        }
export function usePageDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.PageDetailsQuery, Types.PageDetailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.PageDetailsQuery, Types.PageDetailsQueryVariables>(PageDetailsDocument, options);
        }
export type PageDetailsQueryHookResult = ReturnType<typeof usePageDetailsQuery>;
export type PageDetailsLazyQueryHookResult = ReturnType<typeof usePageDetailsLazyQuery>;
export type PageDetailsSuspenseQueryHookResult = ReturnType<typeof usePageDetailsSuspenseQuery>;
export type PageDetailsQueryResult = Apollo.QueryResult<Types.PageDetailsQuery, Types.PageDetailsQueryVariables>;
export const UserComparisonListDocument = gql`
    query UserComparisonList {
  me {
    comparison {
      ...ProductVariantBasic
    }
  }
}
    ${ProductVariantBasicFragmentDoc}`;

/**
 * __useUserComparisonListQuery__
 *
 * To run a query within a React component, call `useUserComparisonListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserComparisonListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserComparisonListQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserComparisonListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.UserComparisonListQuery, Types.UserComparisonListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.UserComparisonListQuery, Types.UserComparisonListQueryVariables>(UserComparisonListDocument, options);
      }
export function useUserComparisonListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.UserComparisonListQuery, Types.UserComparisonListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.UserComparisonListQuery, Types.UserComparisonListQueryVariables>(UserComparisonListDocument, options);
        }
export function useUserComparisonListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.UserComparisonListQuery, Types.UserComparisonListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.UserComparisonListQuery, Types.UserComparisonListQueryVariables>(UserComparisonListDocument, options);
        }
export type UserComparisonListQueryHookResult = ReturnType<typeof useUserComparisonListQuery>;
export type UserComparisonListLazyQueryHookResult = ReturnType<typeof useUserComparisonListLazyQuery>;
export type UserComparisonListSuspenseQueryHookResult = ReturnType<typeof useUserComparisonListSuspenseQuery>;
export type UserComparisonListQueryResult = Apollo.QueryResult<Types.UserComparisonListQuery, Types.UserComparisonListQueryVariables>;
export const UserViewedVariantsDocument = gql`
    query UserViewedVariants($first: Int, $after: String, $before: String, $last: Int) {
  me {
    viewedVariants(first: $first, after: $after, before: $before, last: $last) {
      edges {
        node {
          ...ProductVariantBasic
        }
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
    ${ProductVariantBasicFragmentDoc}`;

/**
 * __useUserViewedVariantsQuery__
 *
 * To run a query within a React component, call `useUserViewedVariantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserViewedVariantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserViewedVariantsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useUserViewedVariantsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.UserViewedVariantsQuery, Types.UserViewedVariantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.UserViewedVariantsQuery, Types.UserViewedVariantsQueryVariables>(UserViewedVariantsDocument, options);
      }
export function useUserViewedVariantsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.UserViewedVariantsQuery, Types.UserViewedVariantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.UserViewedVariantsQuery, Types.UserViewedVariantsQueryVariables>(UserViewedVariantsDocument, options);
        }
export function useUserViewedVariantsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.UserViewedVariantsQuery, Types.UserViewedVariantsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.UserViewedVariantsQuery, Types.UserViewedVariantsQueryVariables>(UserViewedVariantsDocument, options);
        }
export type UserViewedVariantsQueryHookResult = ReturnType<typeof useUserViewedVariantsQuery>;
export type UserViewedVariantsLazyQueryHookResult = ReturnType<typeof useUserViewedVariantsLazyQuery>;
export type UserViewedVariantsSuspenseQueryHookResult = ReturnType<typeof useUserViewedVariantsSuspenseQuery>;
export type UserViewedVariantsQueryResult = Apollo.QueryResult<Types.UserViewedVariantsQuery, Types.UserViewedVariantsQueryVariables>;
export const UserFavoritesDocument = gql`
    query userFavorites($first: Int, $sortBy: ProductVariantSortingInput) {
  me {
    favorites(first: $first, sortBy: $sortBy) {
      edges {
        node {
          ...ProductVariantBasic
        }
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
    ${ProductVariantBasicFragmentDoc}`;

/**
 * __useUserFavoritesQuery__
 *
 * To run a query within a React component, call `useUserFavoritesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserFavoritesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserFavoritesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useUserFavoritesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.UserFavoritesQuery, Types.UserFavoritesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.UserFavoritesQuery, Types.UserFavoritesQueryVariables>(UserFavoritesDocument, options);
      }
export function useUserFavoritesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.UserFavoritesQuery, Types.UserFavoritesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.UserFavoritesQuery, Types.UserFavoritesQueryVariables>(UserFavoritesDocument, options);
        }
export function useUserFavoritesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.UserFavoritesQuery, Types.UserFavoritesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.UserFavoritesQuery, Types.UserFavoritesQueryVariables>(UserFavoritesDocument, options);
        }
export type UserFavoritesQueryHookResult = ReturnType<typeof useUserFavoritesQuery>;
export type UserFavoritesLazyQueryHookResult = ReturnType<typeof useUserFavoritesLazyQuery>;
export type UserFavoritesSuspenseQueryHookResult = ReturnType<typeof useUserFavoritesSuspenseQuery>;
export type UserFavoritesQueryResult = Apollo.QueryResult<Types.UserFavoritesQuery, Types.UserFavoritesQueryVariables>;
export const SearchTabsDocument = gql`
    query searchTabs($variants: [ID!], $first: Int) {
  searchTabs(variants: $variants, first: $first) {
    edges {
      node
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useSearchTabsQuery__
 *
 * To run a query within a React component, call `useSearchTabsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTabsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTabsQuery({
 *   variables: {
 *      variants: // value for 'variants'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useSearchTabsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.SearchTabsQuery, Types.SearchTabsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.SearchTabsQuery, Types.SearchTabsQueryVariables>(SearchTabsDocument, options);
      }
export function useSearchTabsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.SearchTabsQuery, Types.SearchTabsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.SearchTabsQuery, Types.SearchTabsQueryVariables>(SearchTabsDocument, options);
        }
export function useSearchTabsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.SearchTabsQuery, Types.SearchTabsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.SearchTabsQuery, Types.SearchTabsQueryVariables>(SearchTabsDocument, options);
        }
export type SearchTabsQueryHookResult = ReturnType<typeof useSearchTabsQuery>;
export type SearchTabsLazyQueryHookResult = ReturnType<typeof useSearchTabsLazyQuery>;
export type SearchTabsSuspenseQueryHookResult = ReturnType<typeof useSearchTabsSuspenseQuery>;
export type SearchTabsQueryResult = Apollo.QueryResult<Types.SearchTabsQuery, Types.SearchTabsQueryVariables>;
export const MeDocument = gql`
    query me {
  me {
    ...UserBasic
  }
}
    ${UserBasicFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.MeQuery, Types.MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.MeQuery, Types.MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.MeQuery, Types.MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.MeQuery, Types.MeQueryVariables>(MeDocument, options);
        }
export function useMeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.MeQuery, Types.MeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.MeQuery, Types.MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeSuspenseQueryHookResult = ReturnType<typeof useMeSuspenseQuery>;
export type MeQueryResult = Apollo.QueryResult<Types.MeQuery, Types.MeQueryVariables>;
export const MenuItemListDocument = gql`
    query MenuItemList($first: Int, $after: String, $last: Int, $before: String, $sort: MenuSortingInput, $languageCode: LanguageCodeEnum!) {
  menus(first: $first, after: $after, before: $before, last: $last, sortBy: $sort) {
    edges {
      node {
        ...MenuDetails
        items {
          translation(languageCode: $languageCode) {
            name
          }
        }
      }
      cursor
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    ${MenuDetailsFragmentDoc}`;

/**
 * __useMenuItemListQuery__
 *
 * To run a query within a React component, call `useMenuItemListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMenuItemListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMenuItemListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      sort: // value for 'sort'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useMenuItemListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.MenuItemListQuery, Types.MenuItemListQueryVariables> & ({ variables: Types.MenuItemListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.MenuItemListQuery, Types.MenuItemListQueryVariables>(MenuItemListDocument, options);
      }
export function useMenuItemListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.MenuItemListQuery, Types.MenuItemListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.MenuItemListQuery, Types.MenuItemListQueryVariables>(MenuItemListDocument, options);
        }
export function useMenuItemListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.MenuItemListQuery, Types.MenuItemListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.MenuItemListQuery, Types.MenuItemListQueryVariables>(MenuItemListDocument, options);
        }
export type MenuItemListQueryHookResult = ReturnType<typeof useMenuItemListQuery>;
export type MenuItemListLazyQueryHookResult = ReturnType<typeof useMenuItemListLazyQuery>;
export type MenuItemListSuspenseQueryHookResult = ReturnType<typeof useMenuItemListSuspenseQuery>;
export type MenuItemListQueryResult = Apollo.QueryResult<Types.MenuItemListQuery, Types.MenuItemListQueryVariables>;
export const DraftOrderDocument = gql`
    query draftOrder($id: ID!) {
  draftOrder(id: $id) {
    ...OrderFragment
  }
}
    ${OrderFragmentFragmentDoc}`;

/**
 * __useDraftOrderQuery__
 *
 * To run a query within a React component, call `useDraftOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useDraftOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDraftOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDraftOrderQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.DraftOrderQuery, Types.DraftOrderQueryVariables> & ({ variables: Types.DraftOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.DraftOrderQuery, Types.DraftOrderQueryVariables>(DraftOrderDocument, options);
      }
export function useDraftOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.DraftOrderQuery, Types.DraftOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.DraftOrderQuery, Types.DraftOrderQueryVariables>(DraftOrderDocument, options);
        }
export function useDraftOrderSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.DraftOrderQuery, Types.DraftOrderQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.DraftOrderQuery, Types.DraftOrderQueryVariables>(DraftOrderDocument, options);
        }
export type DraftOrderQueryHookResult = ReturnType<typeof useDraftOrderQuery>;
export type DraftOrderLazyQueryHookResult = ReturnType<typeof useDraftOrderLazyQuery>;
export type DraftOrderSuspenseQueryHookResult = ReturnType<typeof useDraftOrderSuspenseQuery>;
export type DraftOrderQueryResult = Apollo.QueryResult<Types.DraftOrderQuery, Types.DraftOrderQueryVariables>;
export const OrdersListDocument = gql`
    query OrdersList($after: String, $before: String, $channel: String, $first: Int, $last: Int, $sortBy: OrderSortingInput, $filter: OrderFilterInput) {
  orders(
    after: $after
    before: $before
    first: $first
    last: $last
    channel: $channel
    sortBy: $sortBy
    filter: $filter
  ) {
    edges {
      node {
        ...OrderFragment
      }
    }
  }
}
    ${OrderFragmentFragmentDoc}`;

/**
 * __useOrdersListQuery__
 *
 * To run a query within a React component, call `useOrdersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersListQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      channel: // value for 'channel'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      sortBy: // value for 'sortBy'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOrdersListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.OrdersListQuery, Types.OrdersListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.OrdersListQuery, Types.OrdersListQueryVariables>(OrdersListDocument, options);
      }
export function useOrdersListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.OrdersListQuery, Types.OrdersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.OrdersListQuery, Types.OrdersListQueryVariables>(OrdersListDocument, options);
        }
export function useOrdersListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.OrdersListQuery, Types.OrdersListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.OrdersListQuery, Types.OrdersListQueryVariables>(OrdersListDocument, options);
        }
export type OrdersListQueryHookResult = ReturnType<typeof useOrdersListQuery>;
export type OrdersListLazyQueryHookResult = ReturnType<typeof useOrdersListLazyQuery>;
export type OrdersListSuspenseQueryHookResult = ReturnType<typeof useOrdersListSuspenseQuery>;
export type OrdersListQueryResult = Apollo.QueryResult<Types.OrdersListQuery, Types.OrdersListQueryVariables>;
export const OrderDocument = gql`
    query Order($id: ID) {
  order(id: $id) {
    ...OrderBasic
  }
}
    ${OrderBasicFragmentDoc}`;

/**
 * __useOrderQuery__
 *
 * To run a query within a React component, call `useOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrderQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.OrderQuery, Types.OrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.OrderQuery, Types.OrderQueryVariables>(OrderDocument, options);
      }
export function useOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.OrderQuery, Types.OrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.OrderQuery, Types.OrderQueryVariables>(OrderDocument, options);
        }
export function useOrderSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.OrderQuery, Types.OrderQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.OrderQuery, Types.OrderQueryVariables>(OrderDocument, options);
        }
export type OrderQueryHookResult = ReturnType<typeof useOrderQuery>;
export type OrderLazyQueryHookResult = ReturnType<typeof useOrderLazyQuery>;
export type OrderSuspenseQueryHookResult = ReturnType<typeof useOrderSuspenseQuery>;
export type OrderQueryResult = Apollo.QueryResult<Types.OrderQuery, Types.OrderQueryVariables>;
export const UserDraftOrdersDocument = gql`
    query userDraftOrders($userId: ID!) {
  userDraftOrders(userId: $userId) {
    ...OrderFragment
  }
}
    ${OrderFragmentFragmentDoc}`;

/**
 * __useUserDraftOrdersQuery__
 *
 * To run a query within a React component, call `useUserDraftOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDraftOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDraftOrdersQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserDraftOrdersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.UserDraftOrdersQuery, Types.UserDraftOrdersQueryVariables> & ({ variables: Types.UserDraftOrdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.UserDraftOrdersQuery, Types.UserDraftOrdersQueryVariables>(UserDraftOrdersDocument, options);
      }
export function useUserDraftOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.UserDraftOrdersQuery, Types.UserDraftOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.UserDraftOrdersQuery, Types.UserDraftOrdersQueryVariables>(UserDraftOrdersDocument, options);
        }
export function useUserDraftOrdersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.UserDraftOrdersQuery, Types.UserDraftOrdersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.UserDraftOrdersQuery, Types.UserDraftOrdersQueryVariables>(UserDraftOrdersDocument, options);
        }
export type UserDraftOrdersQueryHookResult = ReturnType<typeof useUserDraftOrdersQuery>;
export type UserDraftOrdersLazyQueryHookResult = ReturnType<typeof useUserDraftOrdersLazyQuery>;
export type UserDraftOrdersSuspenseQueryHookResult = ReturnType<typeof useUserDraftOrdersSuspenseQuery>;
export type UserDraftOrdersQueryResult = Apollo.QueryResult<Types.UserDraftOrdersQuery, Types.UserDraftOrdersQueryVariables>;
export const UserOrdersDocument = gql`
    query userOrders($userId: ID!) {
  userDraftOrders(userId: $userId) {
    ...OrderBasic
  }
}
    ${OrderBasicFragmentDoc}`;

/**
 * __useUserOrdersQuery__
 *
 * To run a query within a React component, call `useUserOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserOrdersQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserOrdersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.UserOrdersQuery, Types.UserOrdersQueryVariables> & ({ variables: Types.UserOrdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.UserOrdersQuery, Types.UserOrdersQueryVariables>(UserOrdersDocument, options);
      }
export function useUserOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.UserOrdersQuery, Types.UserOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.UserOrdersQuery, Types.UserOrdersQueryVariables>(UserOrdersDocument, options);
        }
export function useUserOrdersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.UserOrdersQuery, Types.UserOrdersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.UserOrdersQuery, Types.UserOrdersQueryVariables>(UserOrdersDocument, options);
        }
export type UserOrdersQueryHookResult = ReturnType<typeof useUserOrdersQuery>;
export type UserOrdersLazyQueryHookResult = ReturnType<typeof useUserOrdersLazyQuery>;
export type UserOrdersSuspenseQueryHookResult = ReturnType<typeof useUserOrdersSuspenseQuery>;
export type UserOrdersQueryResult = Apollo.QueryResult<Types.UserOrdersQuery, Types.UserOrdersQueryVariables>;
export const PaymentTabsDocument = gql`
    query PaymentTabs($first: Int, $last: Int, $after: String, $before: String, $filter: PaymentTabFilterInput, $languageCode: LanguageCodeEnum!) {
  paymentTabs(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      node {
        ...PaymentTabBasic
      }
    }
    totalCount
  }
}
    ${PaymentTabBasicFragmentDoc}`;

/**
 * __usePaymentTabsQuery__
 *
 * To run a query within a React component, call `usePaymentTabsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentTabsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentTabsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function usePaymentTabsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.PaymentTabsQuery, Types.PaymentTabsQueryVariables> & ({ variables: Types.PaymentTabsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.PaymentTabsQuery, Types.PaymentTabsQueryVariables>(PaymentTabsDocument, options);
      }
export function usePaymentTabsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.PaymentTabsQuery, Types.PaymentTabsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.PaymentTabsQuery, Types.PaymentTabsQueryVariables>(PaymentTabsDocument, options);
        }
export function usePaymentTabsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.PaymentTabsQuery, Types.PaymentTabsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.PaymentTabsQuery, Types.PaymentTabsQueryVariables>(PaymentTabsDocument, options);
        }
export type PaymentTabsQueryHookResult = ReturnType<typeof usePaymentTabsQuery>;
export type PaymentTabsLazyQueryHookResult = ReturnType<typeof usePaymentTabsLazyQuery>;
export type PaymentTabsSuspenseQueryHookResult = ReturnType<typeof usePaymentTabsSuspenseQuery>;
export type PaymentTabsQueryResult = Apollo.QueryResult<Types.PaymentTabsQuery, Types.PaymentTabsQueryVariables>;
export const BestsBuysDocument = gql`
    query BestsBuys($first: Int, $after: String, $last: Int, $before: String, $filter: BestBuyFilterInput, $languageCode: LanguageCodeEnum!) {
  bestsBuys(
    first: $first
    after: $after
    last: $last
    before: $before
    filter: $filter
  ) {
    edges {
      node {
        id
        variant {
          ...ProductVariantTranslationsBasic
          translation(languageCode: $languageCode) {
            name
          }
        }
        activeFrom
        activeUntil
      }
      cursor
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    ${ProductVariantTranslationsBasicFragmentDoc}`;

/**
 * __useBestsBuysQuery__
 *
 * To run a query within a React component, call `useBestsBuysQuery` and pass it any options that fit your needs.
 * When your component renders, `useBestsBuysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBestsBuysQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useBestsBuysQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.BestsBuysQuery, Types.BestsBuysQueryVariables> & ({ variables: Types.BestsBuysQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.BestsBuysQuery, Types.BestsBuysQueryVariables>(BestsBuysDocument, options);
      }
export function useBestsBuysLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.BestsBuysQuery, Types.BestsBuysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.BestsBuysQuery, Types.BestsBuysQueryVariables>(BestsBuysDocument, options);
        }
export function useBestsBuysSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.BestsBuysQuery, Types.BestsBuysQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.BestsBuysQuery, Types.BestsBuysQueryVariables>(BestsBuysDocument, options);
        }
export type BestsBuysQueryHookResult = ReturnType<typeof useBestsBuysQuery>;
export type BestsBuysLazyQueryHookResult = ReturnType<typeof useBestsBuysLazyQuery>;
export type BestsBuysSuspenseQueryHookResult = ReturnType<typeof useBestsBuysSuspenseQuery>;
export type BestsBuysQueryResult = Apollo.QueryResult<Types.BestsBuysQuery, Types.BestsBuysQueryVariables>;
export const NewArrivalsDocument = gql`
    query NewArrivals($first: Int, $after: String, $last: Int, $before: String, $filter: NewArrivalFilterInput, $languageCode: LanguageCodeEnum!) {
  newArrivals(
    first: $first
    after: $after
    last: $last
    before: $before
    filter: $filter
  ) {
    edges {
      node {
        id
        variant {
          ...NewArrivalsVariant
        }
        activeFrom
        activeUntil
      }
      cursor
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    ${NewArrivalsVariantFragmentDoc}`;

/**
 * __useNewArrivalsQuery__
 *
 * To run a query within a React component, call `useNewArrivalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewArrivalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewArrivalsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useNewArrivalsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.NewArrivalsQuery, Types.NewArrivalsQueryVariables> & ({ variables: Types.NewArrivalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.NewArrivalsQuery, Types.NewArrivalsQueryVariables>(NewArrivalsDocument, options);
      }
export function useNewArrivalsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.NewArrivalsQuery, Types.NewArrivalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.NewArrivalsQuery, Types.NewArrivalsQueryVariables>(NewArrivalsDocument, options);
        }
export function useNewArrivalsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.NewArrivalsQuery, Types.NewArrivalsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.NewArrivalsQuery, Types.NewArrivalsQueryVariables>(NewArrivalsDocument, options);
        }
export type NewArrivalsQueryHookResult = ReturnType<typeof useNewArrivalsQuery>;
export type NewArrivalsLazyQueryHookResult = ReturnType<typeof useNewArrivalsLazyQuery>;
export type NewArrivalsSuspenseQueryHookResult = ReturnType<typeof useNewArrivalsSuspenseQuery>;
export type NewArrivalsQueryResult = Apollo.QueryResult<Types.NewArrivalsQuery, Types.NewArrivalsQueryVariables>;
export const ProductListDocument = gql`
    query ProductList($first: Int, $channel: String) {
  products(first: $first, channel: $channel) {
    edges {
      node {
        id
        name
        slug
        description
        seoTitle
        rating
      }
    }
  }
}
    `;

/**
 * __useProductListQuery__
 *
 * To run a query within a React component, call `useProductListQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      channel: // value for 'channel'
 *   },
 * });
 */
export function useProductListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ProductListQuery, Types.ProductListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ProductListQuery, Types.ProductListQueryVariables>(ProductListDocument, options);
      }
export function useProductListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ProductListQuery, Types.ProductListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ProductListQuery, Types.ProductListQueryVariables>(ProductListDocument, options);
        }
export function useProductListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ProductListQuery, Types.ProductListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ProductListQuery, Types.ProductListQueryVariables>(ProductListDocument, options);
        }
export type ProductListQueryHookResult = ReturnType<typeof useProductListQuery>;
export type ProductListLazyQueryHookResult = ReturnType<typeof useProductListLazyQuery>;
export type ProductListSuspenseQueryHookResult = ReturnType<typeof useProductListSuspenseQuery>;
export type ProductListQueryResult = Apollo.QueryResult<Types.ProductListQuery, Types.ProductListQueryVariables>;
export const ProductDocument = gql`
    query Product($id: ID, $channel: String, $slug: String, $slugLanguageCode: LanguageCodeEnum, $similarProductsFilter: ProductFilterInput, $languageCode: LanguageCodeEnum!) {
  product(
    id: $id
    channel: $channel
    slug: $slug
    slugLanguageCode: $slugLanguageCode
  ) {
    ...ProductBasic
    translation(languageCode: $languageCode) {
      name
    }
  }
}
    ${ProductBasicFragmentDoc}`;

/**
 * __useProductQuery__
 *
 * To run a query within a React component, call `useProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *      channel: // value for 'channel'
 *      slug: // value for 'slug'
 *      slugLanguageCode: // value for 'slugLanguageCode'
 *      similarProductsFilter: // value for 'similarProductsFilter'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useProductQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ProductQuery, Types.ProductQueryVariables> & ({ variables: Types.ProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ProductQuery, Types.ProductQueryVariables>(ProductDocument, options);
      }
export function useProductLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ProductQuery, Types.ProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ProductQuery, Types.ProductQueryVariables>(ProductDocument, options);
        }
export function useProductSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ProductQuery, Types.ProductQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ProductQuery, Types.ProductQueryVariables>(ProductDocument, options);
        }
export type ProductQueryHookResult = ReturnType<typeof useProductQuery>;
export type ProductLazyQueryHookResult = ReturnType<typeof useProductLazyQuery>;
export type ProductSuspenseQueryHookResult = ReturnType<typeof useProductSuspenseQuery>;
export type ProductQueryResult = Apollo.QueryResult<Types.ProductQuery, Types.ProductQueryVariables>;
export const ProductSeoDocument = gql`
    query ProductSEO($id: ID, $channel: String, $languageCode: LanguageCodeEnum!) {
  product(id: $id, channel: $channel) {
    id
    name
    translation(languageCode: $languageCode) {
      name
    }
    thumbnail(size: 200) {
      url
      alt
    }
    variants {
      id
      name
      seoTitle
      metaDescription
      translation(languageCode: $languageCode) {
        name
      }
    }
  }
}
    `;

/**
 * __useProductSeoQuery__
 *
 * To run a query within a React component, call `useProductSeoQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductSeoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductSeoQuery({
 *   variables: {
 *      id: // value for 'id'
 *      channel: // value for 'channel'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useProductSeoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ProductSeoQuery, Types.ProductSeoQueryVariables> & ({ variables: Types.ProductSeoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ProductSeoQuery, Types.ProductSeoQueryVariables>(ProductSeoDocument, options);
      }
export function useProductSeoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ProductSeoQuery, Types.ProductSeoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ProductSeoQuery, Types.ProductSeoQueryVariables>(ProductSeoDocument, options);
        }
export function useProductSeoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ProductSeoQuery, Types.ProductSeoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ProductSeoQuery, Types.ProductSeoQueryVariables>(ProductSeoDocument, options);
        }
export type ProductSeoQueryHookResult = ReturnType<typeof useProductSeoQuery>;
export type ProductSeoLazyQueryHookResult = ReturnType<typeof useProductSeoLazyQuery>;
export type ProductSeoSuspenseQueryHookResult = ReturnType<typeof useProductSeoSuspenseQuery>;
export type ProductSeoQueryResult = Apollo.QueryResult<Types.ProductSeoQuery, Types.ProductSeoQueryVariables>;
export const GetProductsDocument = gql`
    query GetProducts($first: Int, $after: String, $filter: ProductFilterInput, $similarProductsFilter: ProductFilterInput, $languageCode: LanguageCodeEnum!) {
  products(first: $first, after: $after, filter: $filter) {
    edges {
      node {
        ...ProductBasic
        translation(languageCode: $languageCode) {
          name
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${ProductBasicFragmentDoc}`;

/**
 * __useGetProductsQuery__
 *
 * To run a query within a React component, call `useGetProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      similarProductsFilter: // value for 'similarProductsFilter'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useGetProductsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.GetProductsQuery, Types.GetProductsQueryVariables> & ({ variables: Types.GetProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetProductsQuery, Types.GetProductsQueryVariables>(GetProductsDocument, options);
      }
export function useGetProductsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetProductsQuery, Types.GetProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetProductsQuery, Types.GetProductsQueryVariables>(GetProductsDocument, options);
        }
export function useGetProductsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.GetProductsQuery, Types.GetProductsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.GetProductsQuery, Types.GetProductsQueryVariables>(GetProductsDocument, options);
        }
export type GetProductsQueryHookResult = ReturnType<typeof useGetProductsQuery>;
export type GetProductsLazyQueryHookResult = ReturnType<typeof useGetProductsLazyQuery>;
export type GetProductsSuspenseQueryHookResult = ReturnType<typeof useGetProductsSuspenseQuery>;
export type GetProductsQueryResult = Apollo.QueryResult<Types.GetProductsQuery, Types.GetProductsQueryVariables>;
export const ProductVariantsDocument = gql`
    query ProductVariants($first: Int, $last: Int, $filter: ProductVariantFilterInput, $where: ProductVariantWhereInput, $sortBy: ProductVariantSortingInput, $before: String, $after: String, $ids: [ID!], $city: String!, $languageCode: LanguageCodeEnum!) {
  productVariants(
    first: $first
    last: $last
    filter: $filter
    where: $where
    sortBy: $sortBy
    before: $before
    after: $after
    ids: $ids
  ) {
    edges {
      node {
        ...ProductVariantTranslationsBasic
        storesAvailable(city: $city)
        translation(languageCode: $languageCode) {
          name
        }
      }
      cursor
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    ${ProductVariantTranslationsBasicFragmentDoc}`;

/**
 * __useProductVariantsQuery__
 *
 * To run a query within a React component, call `useProductVariantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductVariantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductVariantsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      filter: // value for 'filter'
 *      where: // value for 'where'
 *      sortBy: // value for 'sortBy'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      ids: // value for 'ids'
 *      city: // value for 'city'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useProductVariantsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ProductVariantsQuery, Types.ProductVariantsQueryVariables> & ({ variables: Types.ProductVariantsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ProductVariantsQuery, Types.ProductVariantsQueryVariables>(ProductVariantsDocument, options);
      }
export function useProductVariantsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ProductVariantsQuery, Types.ProductVariantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ProductVariantsQuery, Types.ProductVariantsQueryVariables>(ProductVariantsDocument, options);
        }
export function useProductVariantsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ProductVariantsQuery, Types.ProductVariantsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ProductVariantsQuery, Types.ProductVariantsQueryVariables>(ProductVariantsDocument, options);
        }
export type ProductVariantsQueryHookResult = ReturnType<typeof useProductVariantsQuery>;
export type ProductVariantsLazyQueryHookResult = ReturnType<typeof useProductVariantsLazyQuery>;
export type ProductVariantsSuspenseQueryHookResult = ReturnType<typeof useProductVariantsSuspenseQuery>;
export type ProductVariantsQueryResult = Apollo.QueryResult<Types.ProductVariantsQuery, Types.ProductVariantsQueryVariables>;
export const ProductVariantDocument = gql`
    query ProductVariant($id: ID, $sku: String, $channel: String, $city: String!, $languageCode: LanguageCodeEnum!) {
  productVariant(id: $id, sku: $sku, channel: $channel) {
    ...ProductVariantTranslationsBasic
    storesAvailable(city: $city)
    translation(languageCode: $languageCode) {
      name
    }
  }
}
    ${ProductVariantTranslationsBasicFragmentDoc}`;

/**
 * __useProductVariantQuery__
 *
 * To run a query within a React component, call `useProductVariantQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductVariantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductVariantQuery({
 *   variables: {
 *      id: // value for 'id'
 *      sku: // value for 'sku'
 *      channel: // value for 'channel'
 *      city: // value for 'city'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useProductVariantQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ProductVariantQuery, Types.ProductVariantQueryVariables> & ({ variables: Types.ProductVariantQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ProductVariantQuery, Types.ProductVariantQueryVariables>(ProductVariantDocument, options);
      }
export function useProductVariantLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ProductVariantQuery, Types.ProductVariantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ProductVariantQuery, Types.ProductVariantQueryVariables>(ProductVariantDocument, options);
        }
export function useProductVariantSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ProductVariantQuery, Types.ProductVariantQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ProductVariantQuery, Types.ProductVariantQueryVariables>(ProductVariantDocument, options);
        }
export type ProductVariantQueryHookResult = ReturnType<typeof useProductVariantQuery>;
export type ProductVariantLazyQueryHookResult = ReturnType<typeof useProductVariantLazyQuery>;
export type ProductVariantSuspenseQueryHookResult = ReturnType<typeof useProductVariantSuspenseQuery>;
export type ProductVariantQueryResult = Apollo.QueryResult<Types.ProductVariantQuery, Types.ProductVariantQueryVariables>;
export const ProductVariantDetailDocument = gql`
    query ProductVariantDetail($id: ID, $languageCode: LanguageCodeEnum!) {
  productVariant(id: $id) {
    seoTitle
    metaDescription
    product {
      name
      seoTitle
      metaDescription
      thumbnail(size: 200) {
        url
        alt
      }
      translation(languageCode: $languageCode) {
        name
      }
    }
  }
}
    `;

/**
 * __useProductVariantDetailQuery__
 *
 * To run a query within a React component, call `useProductVariantDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductVariantDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductVariantDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useProductVariantDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ProductVariantDetailQuery, Types.ProductVariantDetailQueryVariables> & ({ variables: Types.ProductVariantDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ProductVariantDetailQuery, Types.ProductVariantDetailQueryVariables>(ProductVariantDetailDocument, options);
      }
export function useProductVariantDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ProductVariantDetailQuery, Types.ProductVariantDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ProductVariantDetailQuery, Types.ProductVariantDetailQueryVariables>(ProductVariantDetailDocument, options);
        }
export function useProductVariantDetailSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ProductVariantDetailQuery, Types.ProductVariantDetailQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ProductVariantDetailQuery, Types.ProductVariantDetailQueryVariables>(ProductVariantDetailDocument, options);
        }
export type ProductVariantDetailQueryHookResult = ReturnType<typeof useProductVariantDetailQuery>;
export type ProductVariantDetailLazyQueryHookResult = ReturnType<typeof useProductVariantDetailLazyQuery>;
export type ProductVariantDetailSuspenseQueryHookResult = ReturnType<typeof useProductVariantDetailSuspenseQuery>;
export type ProductVariantDetailQueryResult = Apollo.QueryResult<Types.ProductVariantDetailQuery, Types.ProductVariantDetailQueryVariables>;
export const TopProductsDocument = gql`
    query TopProducts($first: Int, $after: String, $last: Int, $before: String, $filter: TopProductFilterInput, $sortBy: HomePageSortingInput, $languageCode: LanguageCodeEnum!) {
  topProducts(
    first: $first
    after: $after
    last: $last
    before: $before
    filter: $filter
    sortBy: $sortBy
  ) {
    edges {
      node {
        id
        variant {
          ...TopProductVariant
        }
        activeFrom
        activeUntil
      }
      cursor
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    ${TopProductVariantFragmentDoc}`;

/**
 * __useTopProductsQuery__
 *
 * To run a query within a React component, call `useTopProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopProductsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *      sortBy: // value for 'sortBy'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useTopProductsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.TopProductsQuery, Types.TopProductsQueryVariables> & ({ variables: Types.TopProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.TopProductsQuery, Types.TopProductsQueryVariables>(TopProductsDocument, options);
      }
export function useTopProductsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.TopProductsQuery, Types.TopProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.TopProductsQuery, Types.TopProductsQueryVariables>(TopProductsDocument, options);
        }
export function useTopProductsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.TopProductsQuery, Types.TopProductsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.TopProductsQuery, Types.TopProductsQueryVariables>(TopProductsDocument, options);
        }
export type TopProductsQueryHookResult = ReturnType<typeof useTopProductsQuery>;
export type TopProductsLazyQueryHookResult = ReturnType<typeof useTopProductsLazyQuery>;
export type TopProductsSuspenseQueryHookResult = ReturnType<typeof useTopProductsSuspenseQuery>;
export type TopProductsQueryResult = Apollo.QueryResult<Types.TopProductsQuery, Types.TopProductsQueryVariables>;
export const DiscountListDocument = gql`
    query DiscountList($after: String, $before: String, $first: Int, $last: Int, $where: PromotionWhereInput, $sort: PromotionSortingInput, $languageCode: LanguageCodeEnum!) {
  promotions(
    after: $after
    before: $before
    first: $first
    last: $last
    where: $where
    sortBy: $sort
  ) {
    edges {
      node {
        ...DicountDetails
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    ${DicountDetailsFragmentDoc}`;

/**
 * __useDiscountListQuery__
 *
 * To run a query within a React component, call `useDiscountListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscountListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscountListQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      where: // value for 'where'
 *      sort: // value for 'sort'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useDiscountListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.DiscountListQuery, Types.DiscountListQueryVariables> & ({ variables: Types.DiscountListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.DiscountListQuery, Types.DiscountListQueryVariables>(DiscountListDocument, options);
      }
export function useDiscountListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.DiscountListQuery, Types.DiscountListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.DiscountListQuery, Types.DiscountListQueryVariables>(DiscountListDocument, options);
        }
export function useDiscountListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.DiscountListQuery, Types.DiscountListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.DiscountListQuery, Types.DiscountListQueryVariables>(DiscountListDocument, options);
        }
export type DiscountListQueryHookResult = ReturnType<typeof useDiscountListQuery>;
export type DiscountListLazyQueryHookResult = ReturnType<typeof useDiscountListLazyQuery>;
export type DiscountListSuspenseQueryHookResult = ReturnType<typeof useDiscountListSuspenseQuery>;
export type DiscountListQueryResult = Apollo.QueryResult<Types.DiscountListQuery, Types.DiscountListQueryVariables>;
export const DiscountDetailsDocument = gql`
    query DiscountDetails($id: ID!, $sortByCategoriesPerVariants: ProductVariantSortingInput, $languageCode: LanguageCodeEnum!, $after: String, $before: String, $first: Int, $last: Int) {
  promotion(id: $id) {
    id
    name
    image
    innerImage
    description
    startDate
    endDate
    slug
    type
    format
    translation(languageCode: $languageCode) {
      name
    }
    seoTitle
    metaDescription
    metaKeywords
    categoriesPerVariants {
      productVariants(
        after: $after
        before: $before
        first: $first
        last: $last
        sortBy: $sortByCategoriesPerVariants
      ) {
        edges {
          node {
            ...ProductVariantTranslationsBasic
          }
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
          endCursor
          startCursor
        }
        totalCount
      }
      category {
        id
        name
        slug
        level
        translation(languageCode: $languageCode) {
          name
        }
        parent {
          id
          name
          level
          translation(languageCode: $languageCode) {
            name
          }
        }
      }
    }
  }
}
    ${ProductVariantTranslationsBasicFragmentDoc}`;

/**
 * __useDiscountDetailsQuery__
 *
 * To run a query within a React component, call `useDiscountDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscountDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscountDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      sortByCategoriesPerVariants: // value for 'sortByCategoriesPerVariants'
 *      languageCode: // value for 'languageCode'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useDiscountDetailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.DiscountDetailsQuery, Types.DiscountDetailsQueryVariables> & ({ variables: Types.DiscountDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.DiscountDetailsQuery, Types.DiscountDetailsQueryVariables>(DiscountDetailsDocument, options);
      }
export function useDiscountDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.DiscountDetailsQuery, Types.DiscountDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.DiscountDetailsQuery, Types.DiscountDetailsQueryVariables>(DiscountDetailsDocument, options);
        }
export function useDiscountDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.DiscountDetailsQuery, Types.DiscountDetailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.DiscountDetailsQuery, Types.DiscountDetailsQueryVariables>(DiscountDetailsDocument, options);
        }
export type DiscountDetailsQueryHookResult = ReturnType<typeof useDiscountDetailsQuery>;
export type DiscountDetailsLazyQueryHookResult = ReturnType<typeof useDiscountDetailsLazyQuery>;
export type DiscountDetailsSuspenseQueryHookResult = ReturnType<typeof useDiscountDetailsSuspenseQuery>;
export type DiscountDetailsQueryResult = Apollo.QueryResult<Types.DiscountDetailsQuery, Types.DiscountDetailsQueryVariables>;
export const RedirectDocument = gql`
    query redirect($url: String) {
  redirect(url: $url) {
    ...RedirectsBasics
  }
}
    ${RedirectsBasicsFragmentDoc}`;

/**
 * __useRedirectQuery__
 *
 * To run a query within a React component, call `useRedirectQuery` and pass it any options that fit your needs.
 * When your component renders, `useRedirectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRedirectQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useRedirectQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.RedirectQuery, Types.RedirectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.RedirectQuery, Types.RedirectQueryVariables>(RedirectDocument, options);
      }
export function useRedirectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.RedirectQuery, Types.RedirectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.RedirectQuery, Types.RedirectQueryVariables>(RedirectDocument, options);
        }
export function useRedirectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.RedirectQuery, Types.RedirectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.RedirectQuery, Types.RedirectQueryVariables>(RedirectDocument, options);
        }
export type RedirectQueryHookResult = ReturnType<typeof useRedirectQuery>;
export type RedirectLazyQueryHookResult = ReturnType<typeof useRedirectLazyQuery>;
export type RedirectSuspenseQueryHookResult = ReturnType<typeof useRedirectSuspenseQuery>;
export type RedirectQueryResult = Apollo.QueryResult<Types.RedirectQuery, Types.RedirectQueryVariables>;
export const RegionalShippingMethodsDocument = gql`
    query RegionalShippingMethods($first: Int, $after: String, $filter: RegionalShippingMethodFilterInput) {
  regionalShippingMethods(first: $first, after: $after, filter: $filter) {
    edges {
      node {
        id
        name
        description
        image
        isActive
        sortOrder
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
  }
}
    `;

/**
 * __useRegionalShippingMethodsQuery__
 *
 * To run a query within a React component, call `useRegionalShippingMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegionalShippingMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegionalShippingMethodsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRegionalShippingMethodsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.RegionalShippingMethodsQuery, Types.RegionalShippingMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.RegionalShippingMethodsQuery, Types.RegionalShippingMethodsQueryVariables>(RegionalShippingMethodsDocument, options);
      }
export function useRegionalShippingMethodsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.RegionalShippingMethodsQuery, Types.RegionalShippingMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.RegionalShippingMethodsQuery, Types.RegionalShippingMethodsQueryVariables>(RegionalShippingMethodsDocument, options);
        }
export function useRegionalShippingMethodsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.RegionalShippingMethodsQuery, Types.RegionalShippingMethodsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.RegionalShippingMethodsQuery, Types.RegionalShippingMethodsQueryVariables>(RegionalShippingMethodsDocument, options);
        }
export type RegionalShippingMethodsQueryHookResult = ReturnType<typeof useRegionalShippingMethodsQuery>;
export type RegionalShippingMethodsLazyQueryHookResult = ReturnType<typeof useRegionalShippingMethodsLazyQuery>;
export type RegionalShippingMethodsSuspenseQueryHookResult = ReturnType<typeof useRegionalShippingMethodsSuspenseQuery>;
export type RegionalShippingMethodsQueryResult = Apollo.QueryResult<Types.RegionalShippingMethodsQuery, Types.RegionalShippingMethodsQueryVariables>;
export const ReviewsDocument = gql`
    query Reviews($first: Int, $last: Int, $after: String, $before: String, $filter: ReviewFilterInput, $sortBy: ReviewSortingInput) {
  reviews(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
    sortBy: $sortBy
  ) {
    edges {
      node {
        ...ReviewBasic
      }
      cursor
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    ${ReviewBasicFragmentDoc}`;

/**
 * __useReviewsQuery__
 *
 * To run a query within a React component, call `useReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useReviewsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ReviewsQuery, Types.ReviewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ReviewsQuery, Types.ReviewsQueryVariables>(ReviewsDocument, options);
      }
export function useReviewsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ReviewsQuery, Types.ReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ReviewsQuery, Types.ReviewsQueryVariables>(ReviewsDocument, options);
        }
export function useReviewsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ReviewsQuery, Types.ReviewsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ReviewsQuery, Types.ReviewsQueryVariables>(ReviewsDocument, options);
        }
export type ReviewsQueryHookResult = ReturnType<typeof useReviewsQuery>;
export type ReviewsLazyQueryHookResult = ReturnType<typeof useReviewsLazyQuery>;
export type ReviewsSuspenseQueryHookResult = ReturnType<typeof useReviewsSuspenseQuery>;
export type ReviewsQueryResult = Apollo.QueryResult<Types.ReviewsQuery, Types.ReviewsQueryVariables>;
export const SiteSettingsDocument = gql`
    query SiteSettings {
  shop {
    ...Shop
  }
}
    ${ShopFragmentDoc}`;

/**
 * __useSiteSettingsQuery__
 *
 * To run a query within a React component, call `useSiteSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSiteSettingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.SiteSettingsQuery, Types.SiteSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.SiteSettingsQuery, Types.SiteSettingsQueryVariables>(SiteSettingsDocument, options);
      }
export function useSiteSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.SiteSettingsQuery, Types.SiteSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.SiteSettingsQuery, Types.SiteSettingsQueryVariables>(SiteSettingsDocument, options);
        }
export function useSiteSettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.SiteSettingsQuery, Types.SiteSettingsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.SiteSettingsQuery, Types.SiteSettingsQueryVariables>(SiteSettingsDocument, options);
        }
export type SiteSettingsQueryHookResult = ReturnType<typeof useSiteSettingsQuery>;
export type SiteSettingsLazyQueryHookResult = ReturnType<typeof useSiteSettingsLazyQuery>;
export type SiteSettingsSuspenseQueryHookResult = ReturnType<typeof useSiteSettingsSuspenseQuery>;
export type SiteSettingsQueryResult = Apollo.QueryResult<Types.SiteSettingsQuery, Types.SiteSettingsQueryVariables>;
export const StoreBranchesDocument = gql`
    query storeBranches($first: Int, $last: Int, $after: String, $before: String, $filter: StoreBranchFilterInput) {
  storeBranches(
    first: $first
    last: $last
    before: $before
    after: $after
    filter: $filter
  ) {
    edges {
      node {
        ...StoreBranchFragment
      }
      cursor
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    ${StoreBranchFragmentFragmentDoc}`;

/**
 * __useStoreBranchesQuery__
 *
 * To run a query within a React component, call `useStoreBranchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreBranchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreBranchesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useStoreBranchesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.StoreBranchesQuery, Types.StoreBranchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.StoreBranchesQuery, Types.StoreBranchesQueryVariables>(StoreBranchesDocument, options);
      }
export function useStoreBranchesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.StoreBranchesQuery, Types.StoreBranchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.StoreBranchesQuery, Types.StoreBranchesQueryVariables>(StoreBranchesDocument, options);
        }
export function useStoreBranchesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.StoreBranchesQuery, Types.StoreBranchesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.StoreBranchesQuery, Types.StoreBranchesQueryVariables>(StoreBranchesDocument, options);
        }
export type StoreBranchesQueryHookResult = ReturnType<typeof useStoreBranchesQuery>;
export type StoreBranchesLazyQueryHookResult = ReturnType<typeof useStoreBranchesLazyQuery>;
export type StoreBranchesSuspenseQueryHookResult = ReturnType<typeof useStoreBranchesSuspenseQuery>;
export type StoreBranchesQueryResult = Apollo.QueryResult<Types.StoreBranchesQuery, Types.StoreBranchesQueryVariables>;
export const SearchVariantsDocument = gql`
    query SearchVariants($first: Int, $query: String, $ids: [ID!], $sortBy: ProductVariantSortingInput, $category: ID, $last: Int, $after: String, $before: String, $availableForInstallment: Boolean, $onSale: Boolean, $price: PriceRangeInput) {
  search: productVariants(
    first: $first
    ids: $ids
    filter: {search: $query, category: $category, price: $price, availableForInstallment: $availableForInstallment, onSale: $onSale}
    sortBy: $sortBy
    last: $last
    after: $after
    before: $before
  ) {
    edges {
      node {
        ...ProductVariantBasic
      }
      cursor
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${ProductVariantBasicFragmentDoc}`;

/**
 * __useSearchVariantsQuery__
 *
 * To run a query within a React component, call `useSearchVariantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchVariantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchVariantsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      query: // value for 'query'
 *      ids: // value for 'ids'
 *      sortBy: // value for 'sortBy'
 *      category: // value for 'category'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      availableForInstallment: // value for 'availableForInstallment'
 *      onSale: // value for 'onSale'
 *      price: // value for 'price'
 *   },
 * });
 */
export function useSearchVariantsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.SearchVariantsQuery, Types.SearchVariantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.SearchVariantsQuery, Types.SearchVariantsQueryVariables>(SearchVariantsDocument, options);
      }
export function useSearchVariantsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.SearchVariantsQuery, Types.SearchVariantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.SearchVariantsQuery, Types.SearchVariantsQueryVariables>(SearchVariantsDocument, options);
        }
export function useSearchVariantsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.SearchVariantsQuery, Types.SearchVariantsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.SearchVariantsQuery, Types.SearchVariantsQueryVariables>(SearchVariantsDocument, options);
        }
export type SearchVariantsQueryHookResult = ReturnType<typeof useSearchVariantsQuery>;
export type SearchVariantsLazyQueryHookResult = ReturnType<typeof useSearchVariantsLazyQuery>;
export type SearchVariantsSuspenseQueryHookResult = ReturnType<typeof useSearchVariantsSuspenseQuery>;
export type SearchVariantsQueryResult = Apollo.QueryResult<Types.SearchVariantsQuery, Types.SearchVariantsQueryVariables>;
export const UzbekistanCitiesDocument = gql`
    query uzbekistanCities {
  uzbekistanCities
}
    `;

/**
 * __useUzbekistanCitiesQuery__
 *
 * To run a query within a React component, call `useUzbekistanCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUzbekistanCitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUzbekistanCitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUzbekistanCitiesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.UzbekistanCitiesQuery, Types.UzbekistanCitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.UzbekistanCitiesQuery, Types.UzbekistanCitiesQueryVariables>(UzbekistanCitiesDocument, options);
      }
export function useUzbekistanCitiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.UzbekistanCitiesQuery, Types.UzbekistanCitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.UzbekistanCitiesQuery, Types.UzbekistanCitiesQueryVariables>(UzbekistanCitiesDocument, options);
        }
export function useUzbekistanCitiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.UzbekistanCitiesQuery, Types.UzbekistanCitiesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.UzbekistanCitiesQuery, Types.UzbekistanCitiesQueryVariables>(UzbekistanCitiesDocument, options);
        }
export type UzbekistanCitiesQueryHookResult = ReturnType<typeof useUzbekistanCitiesQuery>;
export type UzbekistanCitiesLazyQueryHookResult = ReturnType<typeof useUzbekistanCitiesLazyQuery>;
export type UzbekistanCitiesSuspenseQueryHookResult = ReturnType<typeof useUzbekistanCitiesSuspenseQuery>;
export type UzbekistanCitiesQueryResult = Apollo.QueryResult<Types.UzbekistanCitiesQuery, Types.UzbekistanCitiesQueryVariables>;
export const WarehousesDocument = gql`
    query Warehouses($first: Int, $last: Int, $after: String, $before: String, $filter: WarehouseFilterInput, $sortBy: WarehouseSortingInput) {
  warehouses(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
    sortBy: $sortBy
  ) {
    edges {
      node {
        ...WarehouseBasic
      }
      cursor
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    ${WarehouseBasicFragmentDoc}`;

/**
 * __useWarehousesQuery__
 *
 * To run a query within a React component, call `useWarehousesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWarehousesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWarehousesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useWarehousesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.WarehousesQuery, Types.WarehousesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.WarehousesQuery, Types.WarehousesQueryVariables>(WarehousesDocument, options);
      }
export function useWarehousesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.WarehousesQuery, Types.WarehousesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.WarehousesQuery, Types.WarehousesQueryVariables>(WarehousesDocument, options);
        }
export function useWarehousesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.WarehousesQuery, Types.WarehousesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.WarehousesQuery, Types.WarehousesQueryVariables>(WarehousesDocument, options);
        }
export type WarehousesQueryHookResult = ReturnType<typeof useWarehousesQuery>;
export type WarehousesLazyQueryHookResult = ReturnType<typeof useWarehousesLazyQuery>;
export type WarehousesSuspenseQueryHookResult = ReturnType<typeof useWarehousesSuspenseQuery>;
export type WarehousesQueryResult = Apollo.QueryResult<Types.WarehousesQuery, Types.WarehousesQueryVariables>;